import "../_commonjsHelpers-DaMA6jEr.js";
import Ee from "../events/LocaleChangeEvent.js";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var be = function(e, t) {
  return be = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, be(e, t);
};
function J(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  function r() {
    this.constructor = e;
  }
  be(e, t), e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var N = function() {
  return N = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }, N.apply(this, arguments);
};
function V(e, t, r) {
  if (arguments.length === 2) for (var n, a = 0, o = t.length; a < o; a++) !n && a in t || (n || (n = Array.prototype.slice.call(t, 0, a)), n[a] = t[a]);
  return e.concat(n || Array.prototype.slice.call(t));
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ve = function(e, t) {
  return ve = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, ve(e, t);
};
function ue(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  function r() {
    this.constructor = e;
  }
  ve(e, t), e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var K = function() {
  return K = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }, K.apply(this, arguments);
};
function he(e, t, r) {
  if (arguments.length === 2) for (var n, a = 0, o = t.length; a < o; a++) !n && a in t || (n || (n = Array.prototype.slice.call(t, 0, a)), n[a] = t[a]);
  return e.concat(n || Array.prototype.slice.call(t));
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var y, P, W, ie = function() {
  return ie = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }, ie.apply(this, arguments);
};
function Ae(e) {
  return e.type === P.literal;
}
function zt(e) {
  return e.type === P.argument;
}
function we(e) {
  return e.type === P.number;
}
function Ke(e) {
  return e.type === P.date;
}
function Ge(e) {
  return e.type === P.time;
}
function Be(e) {
  return e.type === P.select;
}
function xe(e) {
  return e.type === P.plural;
}
function wt(e) {
  return e.type === P.pound;
}
function Ze(e) {
  return e.type === P.tag;
}
function Ve(e) {
  return !(!e || typeof e != "object" || e.type !== W.number);
}
function Re(e) {
  return !(!e || typeof e != "object" || e.type !== W.dateTime);
}
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(y || (y = {})), function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
}(P || (P = {})), function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
}(W || (W = {}));
var We = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Kt = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Gt(e) {
  var t = {};
  return e.replace(Kt, function(r) {
    var n = r.length;
    switch (r[0]) {
      case "G":
        t.era = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = n === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][n - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = n === 4 ? "short" : n === 5 ? "narrow" : "short";
        break;
      case "e":
        if (n < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "c":
        if (n < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][n - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][n - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = n < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var A = function() {
  return A = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }, A.apply(this, arguments);
}, Bt = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i, _e, Ie = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, Je = /^(@+)?(\+|#+)?$/g, xt = /(\*)(0+)|(#+)(0+)|(0+)/g, Xe = /^(0+)$/;
function Oe(e) {
  var t = {};
  return e.replace(Je, function(r, n, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length) : a === "+" ? t.minimumSignificantDigits = n.length : n[0] === "#" ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function Ye(e) {
  switch (e) {
    case "sign-auto":
      return { signDisplay: "auto" };
    case "sign-accounting":
    case "()":
      return { currencySign: "accounting" };
    case "sign-always":
    case "+!":
      return { signDisplay: "always" };
    case "sign-accounting-always":
    case "()!":
      return { signDisplay: "always", currencySign: "accounting" };
    case "sign-except-zero":
    case "+?":
      return { signDisplay: "exceptZero" };
    case "sign-accounting-except-zero":
    case "()?":
      return { signDisplay: "exceptZero", currencySign: "accounting" };
    case "sign-never":
    case "+_":
      return { signDisplay: "never" };
  }
}
function Zt(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = { notation: "engineering" }, e = e.slice(2)) : e[0] === "E" && (t = { notation: "scientific" }, e = e.slice(1)), t) {
    var r = e.slice(0, 2);
    if (r === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : r === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !Xe.test(e)) throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Ue(e) {
  var t = Ye(e);
  return t || {};
}
function Vt(e) {
  for (var t = {}, r = 0, n = e; r < n.length; r++) {
    var a = n[r];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = a.options[0].replace(/^(.*?)-/, "");
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = A(A(A({}, t), { notation: "scientific" }), a.options.reduce(function(i, c) {
          return A(A({}, i), Ue(c));
        }, {}));
        continue;
      case "engineering":
        t = A(A(A({}, t), { notation: "engineering" }), a.options.reduce(function(i, c) {
          return A(A({}, i), Ue(c));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "integer-width":
        if (a.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(xt, function(i, c, l, u, d, p) {
          if (c) t.minimumIntegerDigits = l.length;
          else {
            if (u && d) throw new Error("We currently do not support maximum integer digits");
            if (p) throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (Xe.test(a.stem)) t.minimumIntegerDigits = a.stem.length;
    else if (Ie.test(a.stem)) {
      if (a.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(Ie, function(i, c, l, u, d, p) {
        return l === "*" ? t.minimumFractionDigits = c.length : u && u[0] === "#" ? t.maximumFractionDigits = u.length : d && p ? (t.minimumFractionDigits = d.length, t.maximumFractionDigits = d.length + p.length) : (t.minimumFractionDigits = c.length, t.maximumFractionDigits = c.length), "";
      }), a.options.length && (t = A(A({}, t), Oe(a.options[0])));
    } else if (Je.test(a.stem)) t = A(A({}, t), Oe(a.stem));
    else {
      var o = Ye(a.stem);
      o && (t = A(A({}, t), o));
      var s = Zt(a.stem);
      s && (t = A(A({}, t), s));
    }
  }
  return t;
}
var Wt = new RegExp("^" + We.source + "*"), Jt = new RegExp(We.source + "*$");
function L(e, t) {
  return { start: e, end: t };
}
var Xt = !!String.prototype.startsWith, Yt = !!String.fromCodePoint, qt = !!Object.fromEntries, Qt = !!String.prototype.codePointAt, $t = !!String.prototype.trimStart, er = !!String.prototype.trimEnd, tr = Number.isSafeInteger ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, Te = !0;
try {
  Te = ((_e = Qe("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu").exec("a")) === null || _e === void 0 ? void 0 : _e[0]) === "a";
} catch {
  Te = !1;
}
var ye, Ce = Xt ? function(e, t, r) {
  return e.startsWith(t, r);
} : function(e, t, r) {
  return e.slice(r, r + t.length) === t;
}, Se = Yt ? String.fromCodePoint : function() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  for (var r, n = "", a = e.length, o = 0; a > o; ) {
    if ((r = e[o++]) > 1114111) throw RangeError(r + " is not a valid code point");
    n += r < 65536 ? String.fromCharCode(r) : String.fromCharCode(55296 + ((r -= 65536) >> 10), r % 1024 + 56320);
  }
  return n;
}, Me = qt ? Object.fromEntries : function(e) {
  for (var t = {}, r = 0, n = e; r < n.length; r++) {
    var a = n[r], o = a[0], s = a[1];
    t[o] = s;
  }
  return t;
}, qe = Qt ? function(e, t) {
  return e.codePointAt(t);
} : function(e, t) {
  var r = e.length;
  if (!(t < 0 || t >= r)) {
    var n, a = e.charCodeAt(t);
    return a < 55296 || a > 56319 || t + 1 === r || (n = e.charCodeAt(t + 1)) < 56320 || n > 57343 ? a : n - 56320 + (a - 55296 << 10) + 65536;
  }
}, rr = $t ? function(e) {
  return e.trimStart();
} : function(e) {
  return e.replace(Wt, "");
}, nr = er ? function(e) {
  return e.trimEnd();
} : function(e) {
  return e.replace(Jt, "");
};
function Qe(e, t) {
  return new RegExp(e, t);
}
if (Te) {
  var ke = Qe("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  ye = function(e, t) {
    var r;
    return ke.lastIndex = t, (r = ke.exec(e)[1]) !== null && r !== void 0 ? r : "";
  };
} else ye = function(e, t) {
  for (var r = []; ; ) {
    var n = qe(e, t);
    if (n === void 0 || $e(n) || or(n)) break;
    r.push(n), t += n >= 65536 ? 2 : 1;
  }
  return Se.apply(void 0, r);
};
var ar = function() {
  function e(t, r) {
    r === void 0 && (r = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!r.ignoreTag, this.requiresOtherClause = !!r.requiresOtherClause, this.shouldParseSkeletons = !!r.shouldParseSkeletons;
  }
  return e.prototype.parse = function() {
    if (this.offset() !== 0) throw Error("parser can only be used once");
    return this.parseMessage(0, "", !1);
  }, e.prototype.parseMessage = function(t, r, n) {
    for (var a = []; !this.isEOF(); ) {
      var o = this.char();
      if (o === 123) {
        if ((s = this.parseArgument(t, n)).err) return s;
        a.push(s.val);
      } else {
        if (o === 125 && t > 0) break;
        if (o !== 35 || r !== "plural" && r !== "selectordinal") {
          if (o === 60 && !this.ignoreTag && this.peek() === 47) {
            if (n) break;
            return this.error(y.UNMATCHED_CLOSING_TAG, L(this.clonePosition(), this.clonePosition()));
          }
          if (o === 60 && !this.ignoreTag && me(this.peek() || 0)) {
            if ((s = this.parseTag(t, r)).err) return s;
            a.push(s.val);
          } else {
            var s;
            if ((s = this.parseLiteral(t, r)).err) return s;
            a.push(s.val);
          }
        } else {
          var i = this.clonePosition();
          this.bump(), a.push({ type: P.pound, location: L(i, this.clonePosition()) });
        }
      }
    }
    return { val: a, err: null };
  }, e.prototype.parseTag = function(t, r) {
    var n = this.clonePosition();
    this.bump();
    var a = this.parseTagName();
    if (this.bumpSpace(), this.bumpIf("/>")) return { val: { type: P.literal, value: "<" + a + "/>", location: L(n, this.clonePosition()) }, err: null };
    if (this.bumpIf(">")) {
      var o = this.parseMessage(t + 1, r, !0);
      if (o.err) return o;
      var s = o.val, i = this.clonePosition();
      if (this.bumpIf("</")) {
        if (this.isEOF() || !me(this.char())) return this.error(y.INVALID_TAG, L(i, this.clonePosition()));
        var c = this.clonePosition();
        return a !== this.parseTagName() ? this.error(y.UNMATCHED_CLOSING_TAG, L(c, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? { val: { type: P.tag, value: a, children: s, location: L(n, this.clonePosition()) }, err: null } : this.error(y.INVALID_TAG, L(i, this.clonePosition())));
      }
      return this.error(y.UNCLOSED_TAG, L(n, this.clonePosition()));
    }
    return this.error(y.INVALID_TAG, L(n, this.clonePosition()));
  }, e.prototype.parseTagName = function() {
    var t, r = this.offset();
    for (this.bump(); !this.isEOF() && ((t = this.char()) === 45 || t === 46 || t >= 48 && t <= 57 || t === 95 || t >= 97 && t <= 122 || t >= 65 && t <= 90 || t == 183 || t >= 192 && t <= 214 || t >= 216 && t <= 246 || t >= 248 && t <= 893 || t >= 895 && t <= 8191 || t >= 8204 && t <= 8205 || t >= 8255 && t <= 8256 || t >= 8304 && t <= 8591 || t >= 11264 && t <= 12271 || t >= 12289 && t <= 55295 || t >= 63744 && t <= 64975 || t >= 65008 && t <= 65533 || t >= 65536 && t <= 983039); ) this.bump();
    return this.message.slice(r, this.offset());
  }, e.prototype.parseLiteral = function(t, r) {
    for (var n = this.clonePosition(), a = ""; ; ) {
      var o = this.tryParseQuote(r);
      if (o) a += o;
      else {
        var s = this.tryParseUnquoted(t, r);
        if (s) a += s;
        else {
          var i = this.tryParseLeftAngleBracket();
          if (!i) break;
          a += i;
        }
      }
    }
    var c = L(n, this.clonePosition());
    return { val: { type: P.literal, value: a, location: c }, err: null };
  }, e.prototype.tryParseLeftAngleBracket = function() {
    return this.isEOF() || this.char() !== 60 || !this.ignoreTag && (me(t = this.peek() || 0) || t === 47) ? null : (this.bump(), "<");
    var t;
  }, e.prototype.tryParseQuote = function(t) {
    if (this.isEOF() || this.char() !== 39) return null;
    switch (this.peek()) {
      case 39:
        return this.bump(), this.bump(), "'";
      case 123:
      case 60:
      case 62:
      case 125:
        break;
      case 35:
        if (t === "plural" || t === "selectordinal") break;
        return null;
      default:
        return null;
    }
    this.bump();
    var r = [this.char()];
    for (this.bump(); !this.isEOF(); ) {
      var n = this.char();
      if (n === 39) {
        if (this.peek() !== 39) {
          this.bump();
          break;
        }
        r.push(39), this.bump();
      } else r.push(n);
      this.bump();
    }
    return Se.apply(void 0, r);
  }, e.prototype.tryParseUnquoted = function(t, r) {
    if (this.isEOF()) return null;
    var n = this.char();
    return n === 60 || n === 123 || n === 35 && (r === "plural" || r === "selectordinal") || n === 125 && t > 0 ? null : (this.bump(), Se(n));
  }, e.prototype.parseArgument = function(t, r) {
    var n = this.clonePosition();
    if (this.bump(), this.bumpSpace(), this.isEOF()) return this.error(y.EXPECT_ARGUMENT_CLOSING_BRACE, L(n, this.clonePosition()));
    if (this.char() === 125) return this.bump(), this.error(y.EMPTY_ARGUMENT, L(n, this.clonePosition()));
    var a = this.parseIdentifierIfPossible().value;
    if (!a) return this.error(y.MALFORMED_ARGUMENT, L(n, this.clonePosition()));
    if (this.bumpSpace(), this.isEOF()) return this.error(y.EXPECT_ARGUMENT_CLOSING_BRACE, L(n, this.clonePosition()));
    switch (this.char()) {
      case 125:
        return this.bump(), { val: { type: P.argument, value: a, location: L(n, this.clonePosition()) }, err: null };
      case 44:
        return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(y.EXPECT_ARGUMENT_CLOSING_BRACE, L(n, this.clonePosition())) : this.parseArgumentOptions(t, r, a, n);
      default:
        return this.error(y.MALFORMED_ARGUMENT, L(n, this.clonePosition()));
    }
  }, e.prototype.parseIdentifierIfPossible = function() {
    var t = this.clonePosition(), r = this.offset(), n = ye(this.message, r), a = r + n.length;
    return this.bumpTo(a), { value: n, location: L(t, this.clonePosition()) };
  }, e.prototype.parseArgumentOptions = function(t, r, n, a) {
    var o, s = this.clonePosition(), i = this.parseIdentifierIfPossible().value, c = this.clonePosition();
    switch (i) {
      case "":
        return this.error(y.EXPECT_ARGUMENT_TYPE, L(s, c));
      case "number":
      case "date":
      case "time":
        this.bumpSpace();
        var l = null;
        if (this.bumpIf(",")) {
          this.bumpSpace();
          var u = this.clonePosition();
          if ((R = this.parseSimpleArgStyleIfPossible()).err) return R;
          if ((b = nr(R.val)).length === 0) return this.error(y.EXPECT_ARGUMENT_STYLE, L(this.clonePosition(), this.clonePosition()));
          l = { style: b, styleLocation: L(u, this.clonePosition()) };
        }
        if ((T = this.tryParseArgumentClose(a)).err) return T;
        var d = L(a, this.clonePosition());
        if (l && Ce(l == null ? void 0 : l.style, "::", 0)) {
          var p = rr(l.style.slice(2));
          if (i === "number") return (R = this.parseNumberSkeletonFromString(p, l.styleLocation)).err ? R : { val: { type: P.number, value: n, location: d, style: R.val }, err: null };
          if (p.length === 0) return this.error(y.EXPECT_DATE_TIME_SKELETON, d);
          var b = { type: W.dateTime, pattern: p, location: l.styleLocation, parsedOptions: this.shouldParseSkeletons ? Gt(p) : {} };
          return { val: { type: i === "date" ? P.date : P.time, value: n, location: d, style: b }, err: null };
        }
        return { val: { type: i === "number" ? P.number : i === "date" ? P.date : P.time, value: n, location: d, style: (o = l == null ? void 0 : l.style) !== null && o !== void 0 ? o : null }, err: null };
      case "plural":
      case "selectordinal":
      case "select":
        var g = this.clonePosition();
        if (this.bumpSpace(), !this.bumpIf(",")) return this.error(y.EXPECT_SELECT_ARGUMENT_OPTIONS, L(g, ie({}, g)));
        this.bumpSpace();
        var h = this.parseIdentifierIfPossible(), m = 0;
        if (i !== "select" && h.value === "offset") {
          if (!this.bumpIf(":")) return this.error(y.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, L(this.clonePosition(), this.clonePosition()));
          var R;
          if (this.bumpSpace(), (R = this.tryParseDecimalInteger(y.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, y.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE)).err) return R;
          this.bumpSpace(), h = this.parseIdentifierIfPossible(), m = R.val;
        }
        var T, f = this.tryParsePluralOrSelectOptions(t, i, r, h);
        if (f.err) return f;
        if ((T = this.tryParseArgumentClose(a)).err) return T;
        var E = L(a, this.clonePosition());
        return i === "select" ? { val: { type: P.select, value: n, options: Me(f.val), location: E }, err: null } : { val: { type: P.plural, value: n, options: Me(f.val), offset: m, pluralType: i === "plural" ? "cardinal" : "ordinal", location: E }, err: null };
      default:
        return this.error(y.INVALID_ARGUMENT_TYPE, L(s, c));
    }
  }, e.prototype.tryParseArgumentClose = function(t) {
    return this.isEOF() || this.char() !== 125 ? this.error(y.EXPECT_ARGUMENT_CLOSING_BRACE, L(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
  }, e.prototype.parseSimpleArgStyleIfPossible = function() {
    for (var t = 0, r = this.clonePosition(); !this.isEOF(); )
      switch (this.char()) {
        case 39:
          this.bump();
          var n = this.clonePosition();
          if (!this.bumpUntil("'")) return this.error(y.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, L(n, this.clonePosition()));
          this.bump();
          break;
        case 123:
          t += 1, this.bump();
          break;
        case 125:
          if (!(t > 0)) return { val: this.message.slice(r.offset, this.offset()), err: null };
          t -= 1;
          break;
        default:
          this.bump();
      }
    return { val: this.message.slice(r.offset, this.offset()), err: null };
  }, e.prototype.parseNumberSkeletonFromString = function(t, r) {
    var n = [];
    try {
      n = function(a) {
        if (a.length === 0) throw new Error("Number skeleton cannot be empty");
        for (var o = [], s = 0, i = a.split(Bt).filter(function(b) {
          return b.length > 0;
        }); s < i.length; s++) {
          var c = i[s].split("/");
          if (c.length === 0) throw new Error("Invalid number skeleton");
          for (var l = c[0], u = c.slice(1), d = 0, p = u; d < p.length; d++) if (p[d].length === 0) throw new Error("Invalid number skeleton");
          o.push({ stem: l, options: u });
        }
        return o;
      }(t);
    } catch {
      return this.error(y.INVALID_NUMBER_SKELETON, r);
    }
    return { val: { type: W.number, tokens: n, location: r, parsedOptions: this.shouldParseSkeletons ? Vt(n) : {} }, err: null };
  }, e.prototype.tryParsePluralOrSelectOptions = function(t, r, n, a) {
    for (var o, s = !1, i = [], c = /* @__PURE__ */ new Set(), l = a.value, u = a.location; ; ) {
      if (l.length === 0) {
        var d = this.clonePosition();
        if (r === "select" || !this.bumpIf("=")) break;
        var p = this.tryParseDecimalInteger(y.EXPECT_PLURAL_ARGUMENT_SELECTOR, y.INVALID_PLURAL_ARGUMENT_SELECTOR);
        if (p.err) return p;
        u = L(d, this.clonePosition()), l = this.message.slice(d.offset, this.offset());
      }
      if (c.has(l)) return this.error(r === "select" ? y.DUPLICATE_SELECT_ARGUMENT_SELECTOR : y.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, u);
      l === "other" && (s = !0), this.bumpSpace();
      var b = this.clonePosition();
      if (!this.bumpIf("{")) return this.error(r === "select" ? y.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : y.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, L(this.clonePosition(), this.clonePosition()));
      var g = this.parseMessage(t + 1, r, n);
      if (g.err) return g;
      var h = this.tryParseArgumentClose(b);
      if (h.err) return h;
      i.push([l, { value: g.val, location: L(b, this.clonePosition()) }]), c.add(l), this.bumpSpace(), l = (o = this.parseIdentifierIfPossible()).value, u = o.location;
    }
    return i.length === 0 ? this.error(r === "select" ? y.EXPECT_SELECT_ARGUMENT_SELECTOR : y.EXPECT_PLURAL_ARGUMENT_SELECTOR, L(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !s ? this.error(y.MISSING_OTHER_CLAUSE, L(this.clonePosition(), this.clonePosition())) : { val: i, err: null };
  }, e.prototype.tryParseDecimalInteger = function(t, r) {
    var n = 1, a = this.clonePosition();
    this.bumpIf("+") || this.bumpIf("-") && (n = -1);
    for (var o = !1, s = 0; !this.isEOF(); ) {
      var i = this.char();
      if (!(i >= 48 && i <= 57)) break;
      o = !0, s = 10 * s + (i - 48), this.bump();
    }
    var c = L(a, this.clonePosition());
    return o ? tr(s *= n) ? { val: s, err: null } : this.error(r, c) : this.error(t, c);
  }, e.prototype.offset = function() {
    return this.position.offset;
  }, e.prototype.isEOF = function() {
    return this.offset() === this.message.length;
  }, e.prototype.clonePosition = function() {
    return { offset: this.position.offset, line: this.position.line, column: this.position.column };
  }, e.prototype.char = function() {
    var t = this.position.offset;
    if (t >= this.message.length) throw Error("out of bound");
    var r = qe(this.message, t);
    if (r === void 0) throw Error("Offset " + t + " is at invalid UTF-16 code unit boundary");
    return r;
  }, e.prototype.error = function(t, r) {
    return { val: null, err: { kind: t, message: this.message, location: r } };
  }, e.prototype.bump = function() {
    if (!this.isEOF()) {
      var t = this.char();
      t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
    }
  }, e.prototype.bumpIf = function(t) {
    if (Ce(this.message, t, this.offset())) {
      for (var r = 0; r < t.length; r++) this.bump();
      return !0;
    }
    return !1;
  }, e.prototype.bumpUntil = function(t) {
    var r = this.offset(), n = this.message.indexOf(t, r);
    return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
  }, e.prototype.bumpTo = function(t) {
    if (this.offset() > t) throw Error("targetOffset " + t + " must be greater than or equal to the current offset " + this.offset());
    for (t = Math.min(t, this.message.length); ; ) {
      var r = this.offset();
      if (r === t) break;
      if (r > t) throw Error("targetOffset " + t + " is at invalid UTF-16 code unit boundary");
      if (this.bump(), this.isEOF()) break;
    }
  }, e.prototype.bumpSpace = function() {
    for (; !this.isEOF() && $e(this.char()); ) this.bump();
  }, e.prototype.peek = function() {
    if (this.isEOF()) return null;
    var t = this.char(), r = this.offset(), n = this.message.charCodeAt(r + (t >= 65536 ? 2 : 1));
    return n ?? null;
  }, e;
}();
function me(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function $e(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function or(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function Le(e) {
  e.forEach(function(t) {
    if (delete t.location, Be(t) || xe(t)) for (var r in t.options) delete t.options[r].location, Le(t.options[r].value);
    else we(t) && Ve(t.style) || (Ke(t) || Ge(t)) && Re(t.style) ? delete t.style.location : Ze(t) && Le(t.children);
  });
}
function ir(e, t) {
  t === void 0 && (t = {}), t = ie({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var r = new ar(e, t).parse();
  if (r.err) {
    var n = SyntaxError(y[r.err.kind]);
    throw n.location = r.err.location, n.originalMessage = r.err.message, n;
  }
  return t != null && t.captureLocation || Le(r.val), r.val;
}
function D(e, t) {
  var r = t && t.cache ? t.cache : lr, n = t && t.serializer ? t.serializer : ur;
  return (t && t.strategy ? t.strategy : sr)(e, { cache: r, serializer: n });
}
function et(e, t, r, n) {
  var a, o = (a = n) == null || typeof a == "number" || typeof a == "boolean" ? n : r(n), s = t.get(o);
  return s === void 0 && (s = e.call(this, n), t.set(o, s)), s;
}
function tt(e, t, r) {
  var n = Array.prototype.slice.call(arguments, 3), a = r(n), o = t.get(a);
  return o === void 0 && (o = e.apply(this, n), t.set(a, o)), o;
}
function Pe(e, t, r, n, a) {
  return r.bind(t, e, n, a);
}
function sr(e, t) {
  return Pe(e, this, e.length === 1 ? et : tt, t.cache.create(), t.serializer);
}
var ur = function() {
  return JSON.stringify(arguments);
};
function ae() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
ae.prototype.has = function(e) {
  return e in this.cache;
}, ae.prototype.get = function(e) {
  return this.cache[e];
}, ae.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var F, lr = { create: function() {
  return new ae();
} }, H = { variadic: function(e, t) {
  return Pe(e, this, tt, t.cache.create(), t.serializer);
}, monadic: function(e, t) {
  return Pe(e, this, et, t.cache.create(), t.serializer);
} };
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(F || (F = {}));
var U, G = function(e) {
  function t(r, n, a) {
    var o = e.call(this, r) || this;
    return o.code = n, o.originalMessage = a, o;
  }
  return ue(t, e), t.prototype.toString = function() {
    return "[formatjs Error: " + this.code + "] " + this.message;
  }, t;
}(Error), je = function(e) {
  function t(r, n, a, o) {
    return e.call(this, 'Invalid values for "' + r + '": "' + n + '". Options are "' + Object.keys(a).join('", "') + '"', F.INVALID_VALUE, o) || this;
  }
  return ue(t, e), t;
}(G), cr = function(e) {
  function t(r, n, a) {
    return e.call(this, 'Value for "' + r + '" must be of type ' + n, F.INVALID_VALUE, a) || this;
  }
  return ue(t, e), t;
}(G), fr = function(e) {
  function t(r, n) {
    return e.call(this, 'The intl string context variable "' + r + '" was not provided to the string "' + n + '"', F.MISSING_VALUE, n) || this;
  }
  return ue(t, e), t;
}(G);
function pr(e) {
  return typeof e == "function";
}
function oe(e, t, r, n, a, o, s) {
  if (e.length === 1 && Ae(e[0])) return [{ type: U.literal, value: e[0].value }];
  for (var i = [], c = 0, l = e; c < l.length; c++) {
    var u = l[c];
    if (Ae(u)) i.push({ type: U.literal, value: u.value });
    else if (wt(u)) typeof o == "number" && i.push({ type: U.literal, value: r.getNumberFormat(t).format(o) });
    else {
      var d = u.value;
      if (!a || !(d in a)) throw new fr(d, s);
      var p = a[d];
      if (zt(u)) p && typeof p != "string" && typeof p != "number" || (p = typeof p == "string" || typeof p == "number" ? String(p) : ""), i.push({ type: typeof p == "string" ? U.literal : U.object, value: p });
      else if (Ke(u)) {
        var b = typeof u.style == "string" ? n.date[u.style] : Re(u.style) ? u.style.parsedOptions : void 0;
        i.push({ type: U.literal, value: r.getDateTimeFormat(t, b).format(p) });
      } else if (Ge(u))
        b = typeof u.style == "string" ? n.time[u.style] : Re(u.style) ? u.style.parsedOptions : void 0, i.push({ type: U.literal, value: r.getDateTimeFormat(t, b).format(p) });
      else if (we(u))
        (b = typeof u.style == "string" ? n.number[u.style] : Ve(u.style) ? u.style.parsedOptions : void 0) && b.scale && (p *= b.scale || 1), i.push({ type: U.literal, value: r.getNumberFormat(t, b).format(p) });
      else {
        if (Ze(u)) {
          var g = u.children, h = u.value, m = a[h];
          if (!pr(m)) throw new cr(h, "function", s);
          var R = m(oe(g, t, r, n, a, o).map(function(E) {
            return E.value;
          }));
          Array.isArray(R) || (R = [R]), i.push.apply(i, R.map(function(E) {
            return { type: typeof E == "string" ? U.literal : U.object, value: E };
          }));
        }
        if (Be(u)) {
          if (!(T = u.options[p] || u.options.other)) throw new je(u.value, p, Object.keys(u.options), s);
          i.push.apply(i, oe(T.value, t, r, n, a));
        } else if (xe(u)) {
          var T;
          if (!(T = u.options["=" + p])) {
            if (!Intl.PluralRules) throw new G(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, F.MISSING_INTL_API, s);
            var f = r.getPluralRules(t, { type: u.pluralType }).select(p - (u.offset || 0));
            T = u.options[f] || u.options.other;
          }
          if (!T) throw new je(u.value, p, Object.keys(u.options), s);
          i.push.apply(i, oe(T.value, t, r, n, a, p - (u.offset || 0)));
        }
      }
    }
  }
  return function(E) {
    return E.length < 2 ? E : E.reduce(function(v, S) {
      var I = v[v.length - 1];
      return I && I.type === U.literal && S.type === U.literal ? I.value += S.value : v.push(S), v;
    }, []);
  }(i);
}
function dr(e, t) {
  return t ? Object.keys(e).reduce(function(r, n) {
    var a, o;
    return r[n] = (a = e[n], (o = t[n]) ? K(K(K({}, a || {}), o || {}), Object.keys(a).reduce(function(s, i) {
      return s[i] = K(K({}, a[i]), o[i] || {}), s;
    }, {})) : a), r;
  }, K({}, e)) : e;
}
function ge(e) {
  return { create: function() {
    return { has: function(t) {
      return t in e;
    }, get: function(t) {
      return e[t];
    }, set: function(t, r) {
      e[t] = r;
    } };
  } };
}
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(U || (U = {}));
var O, rt = function() {
  function e(t, r, n, a) {
    var o, s = this;
    if (r === void 0 && (r = e.defaultLocale), this.formatterCache = { number: {}, dateTime: {}, pluralRules: {} }, this.format = function(i) {
      var c = s.formatToParts(i);
      if (c.length === 1) return c[0].value;
      var l = c.reduce(function(u, d) {
        return u.length && d.type === U.literal && typeof u[u.length - 1] == "string" ? u[u.length - 1] += d.value : u.push(d.value), u;
      }, []);
      return l.length <= 1 ? l[0] || "" : l;
    }, this.formatToParts = function(i) {
      return oe(s.ast, s.locales, s.formatters, s.formats, i, void 0, s.message);
    }, this.resolvedOptions = function() {
      return { locale: Intl.NumberFormat.supportedLocalesOf(s.locales)[0] };
    }, this.getAst = function() {
      return s.ast;
    }, typeof t == "string") {
      if (this.message = t, !e.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
      this.ast = e.__parse(t, { ignoreTag: a == null ? void 0 : a.ignoreTag });
    } else this.ast = t;
    if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
    this.formats = dr(e.formats, n), this.locales = r, this.formatters = a && a.formatters || ((o = this.formatterCache) === void 0 && (o = { number: {}, dateTime: {}, pluralRules: {} }), { getNumberFormat: D(function() {
      for (var i, c = [], l = 0; l < arguments.length; l++) c[l] = arguments[l];
      return new ((i = Intl.NumberFormat).bind.apply(i, he([void 0], c)))();
    }, { cache: ge(o.number), strategy: H.variadic }), getDateTimeFormat: D(function() {
      for (var i, c = [], l = 0; l < arguments.length; l++) c[l] = arguments[l];
      return new ((i = Intl.DateTimeFormat).bind.apply(i, he([void 0], c)))();
    }, { cache: ge(o.dateTime), strategy: H.variadic }), getPluralRules: D(function() {
      for (var i, c = [], l = 0; l < arguments.length; l++) c[l] = arguments[l];
      return new ((i = Intl.PluralRules).bind.apply(i, he([void 0], c)))();
    }, { cache: ge(o.pluralRules), strategy: H.variadic }) });
  }
  return Object.defineProperty(e, "defaultLocale", { get: function() {
    return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
  }, enumerable: !1, configurable: !0 }), e.memoizedDefaultLocale = null, e.__parse = ir, e.formats = { number: { currency: { style: "currency" }, percent: { style: "percent" } }, date: { short: { month: "numeric", day: "numeric", year: "2-digit" }, medium: { month: "short", day: "numeric", year: "numeric" }, long: { month: "long", day: "numeric", year: "numeric" }, full: { weekday: "long", month: "long", day: "numeric", year: "numeric" } }, time: { short: { hour: "numeric", minute: "numeric" }, medium: { hour: "numeric", minute: "numeric", second: "numeric" }, long: { hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "short" }, full: { hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "short" } } }, e;
}();
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(O || (O = {}));
var C = function(e) {
  function t(r, n, a) {
    var o = e.call(this, "[@formatjs/intl Error " + r + "] " + n + ` 
` + (a ? `
` + a.message + `
` + a.stack : "")) || this;
    return o.code = r, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(o, t), o;
  }
  return J(t, e), t;
}(Error), hr = function(e) {
  function t(r, n) {
    return e.call(this, O.UNSUPPORTED_FORMATTER, r, n) || this;
  }
  return J(t, e), t;
}(C), _r = function(e) {
  function t(r, n) {
    return e.call(this, O.INVALID_CONFIG, r, n) || this;
  }
  return J(t, e), t;
}(C), De = function(e) {
  function t(r, n) {
    return e.call(this, O.MISSING_DATA, r, n) || this;
  }
  return J(t, e), t;
}(C), Y = function(e) {
  function t(r, n, a, o) {
    var s = e.call(this, O.FORMAT_ERROR, r + ` 
Locale: ` + n + `
MessageID: ` + (a == null ? void 0 : a.id) + `
Default Message: ` + (a == null ? void 0 : a.defaultMessage) + `
Description: ` + (a == null ? void 0 : a.description) + ` 
`, o) || this;
    return s.descriptor = a, s;
  }
  return J(t, e), t;
}(C), mr = function(e) {
  function t(r, n) {
    var a = e.call(this, O.MISSING_TRANSLATION, 'Missing message: "' + r.id + '" for locale "' + n + '", using ' + (r.defaultMessage ? "default message" : "id") + " as fallback.") || this;
    return a.descriptor = r, a;
  }
  return J(t, e), t;
}(C);
function Z(e, t, r) {
  return r === void 0 && (r = {}), t.reduce(function(n, a) {
    return a in e ? n[a] = e[a] : a in r && (n[a] = r[a]), n;
  }, {});
}
var gr = { formats: {}, messages: {}, timeZone: void 0, defaultLocale: "en", defaultFormats: {}, onError: function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
} };
function x(e) {
  return { create: function() {
    return { has: function(t) {
      return t in e;
    }, get: function(t) {
      return e[t];
    }, set: function(t, r) {
      e[t] = r;
    } };
  } };
}
function Ne(e, t, r, n) {
  var a, o = e && e[t];
  if (o && (a = o[r]), a) return a;
  n(new hr("No " + t + " format named: " + r));
}
function ne(e, t) {
  return Object.keys(e).reduce(function(r, n) {
    return r[n] = N({ timeZone: t }, e[n]), r;
  }, {});
}
function He(e, t) {
  return Object.keys(N(N({}, e), t)).reduce(function(r, n) {
    return r[n] = N(N({}, e[n] || {}), t[n] || {}), r;
  }, {});
}
function Fe(e, t) {
  if (!t) return e;
  var r = rt.formats;
  return N(N(N({}, r), e), { date: He(ne(r.date, t), ne(e.date || {}, t)), time: He(ne(r.time, t), ne(e.time || {}, t)) });
}
function Er(e, t, r, n, a) {
  var o = e.locale, s = e.formats, i = e.messages, c = e.defaultLocale, l = e.defaultFormats, u = e.onError, d = e.timeZone, p = e.defaultRichTextElements;
  r === void 0 && (r = { id: "" });
  var b = r.id, g = r.defaultMessage;
  (function(R, T, f) {
    if (f === void 0 && (f = Error), !R) throw new f(T);
  })(!!b, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var h = String(b), m = i && Object.prototype.hasOwnProperty.call(i, h) && i[h];
  if (Array.isArray(m) && m.length === 1 && m[0].type === P.literal) return m[0].value;
  if (!n && m && typeof m == "string" && !p) return m.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (n = N(N({}, p), n || {}), s = Fe(s, d), l = Fe(l, d), !m) {
    if ((!g || o && o.toLowerCase() !== c.toLowerCase()) && u(new mr(r, o)), g) try {
      return t.getMessageFormat(g, c, l, a).format(n);
    } catch (R) {
      return u(new Y('Error formatting default message for: "' + h + '", rendering default message verbatim', o, r, R)), typeof g == "string" ? g : h;
    }
    return h;
  }
  try {
    return t.getMessageFormat(m, o, s, N({ formatters: t }, a || {})).format(n);
  } catch (R) {
    u(new Y('Error formatting message: "' + h + '", using ' + (g ? "default message" : "id") + " as fallback.", o, r, R));
  }
  if (g) try {
    return t.getMessageFormat(g, c, l, a).format(n);
  } catch (R) {
    u(new Y('Error formatting the default message for: "' + h + '", rendering message verbatim', o, r, R));
  }
  return typeof m == "string" ? m : typeof g == "string" ? g : h;
}
var nt = ["localeMatcher", "formatMatcher", "timeZone", "hour12", "weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hourCycle", "dateStyle", "timeStyle", "calendar", "numberingSystem"];
function le(e, t, r, n) {
  var a = e.locale, o = e.formats, s = e.onError, i = e.timeZone;
  n === void 0 && (n = {});
  var c = n.format, l = N(N({}, i && { timeZone: i }), c && Ne(o, t, c, s)), u = Z(n, nt, l);
  return t !== "time" || u.hour || u.minute || u.second || u.timeStyle || u.dateStyle || (u = N(N({}, u), { hour: "numeric", minute: "numeric" })), r(a, u);
}
function br(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
  var a = r[0], o = r[1], s = o === void 0 ? {} : o, i = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return le(e, "date", t, s).format(i);
  } catch (c) {
    e.onError(new C(O.FORMAT_ERROR, "Error formatting date.", c));
  }
  return String(i);
}
function vr(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
  var a = r[0], o = r[1], s = o === void 0 ? {} : o, i = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return le(e, "time", t, s).format(i);
  } catch (c) {
    e.onError(new C(O.FORMAT_ERROR, "Error formatting time.", c));
  }
  return String(i);
}
function Rr(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
  var a = r[0], o = r[1], s = r[2], i = s === void 0 ? {} : s, c = e.timeZone, l = e.locale, u = e.onError, d = Z(i, nt, c ? { timeZone: c } : {});
  try {
    return t(l, d).formatRange(a, o);
  } catch (p) {
    u(new C(O.FORMAT_ERROR, "Error formatting date time range.", p));
  }
  return String(a);
}
function Tr(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
  var a = r[0], o = r[1], s = o === void 0 ? {} : o, i = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return le(e, "date", t, s).formatToParts(i);
  } catch (c) {
    e.onError(new C(O.FORMAT_ERROR, "Error formatting date.", c));
  }
  return [];
}
function yr(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
  var a = r[0], o = r[1], s = o === void 0 ? {} : o, i = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return le(e, "time", t, s).formatToParts(i);
  } catch (c) {
    e.onError(new C(O.FORMAT_ERROR, "Error formatting time.", c));
  }
  return [];
}
var Sr = ["localeMatcher", "style", "type", "fallback"];
function Lr(e, t, r, n) {
  var a = e.locale, o = e.onError;
  Intl.DisplayNames || o(new G(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, F.MISSING_INTL_API));
  var s = Z(n, Sr);
  try {
    return t(a, s).of(r);
  } catch (i) {
    o(new C(O.FORMAT_ERROR, "Error formatting display name.", i));
  }
}
var Pr = ["localeMatcher", "type", "style"], ze = Date.now();
function Nr(e, t, r, n) {
  n === void 0 && (n = {});
  var a = at(e, t, r, n).reduce(function(o, s) {
    var i = s.value;
    return typeof i != "string" ? o.push(i) : typeof o[o.length - 1] == "string" ? o[o.length - 1] += i : o.push(i), o;
  }, []);
  return a.length === 1 ? a[0] : a;
}
function at(e, t, r, n) {
  var a = e.locale, o = e.onError;
  n === void 0 && (n = {}), Intl.ListFormat || o(new G(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, F.MISSING_INTL_API));
  var s = Z(n, Pr);
  try {
    var i = {}, c = r.map(function(l, u) {
      if (typeof l == "object") {
        var d = function(p) {
          return ze + "_" + p + "_" + ze;
        }(u);
        return i[d] = l, d;
      }
      return String(l);
    });
    return t(a, s).formatToParts(c).map(function(l) {
      return l.type === "literal" ? l : N(N({}, l), { value: i[l.value] || l.value });
    });
  } catch (l) {
    o(new C(O.FORMAT_ERROR, "Error formatting list.", l));
  }
  return r;
}
var Ar = ["localeMatcher", "type"];
function Ir(e, t, r, n) {
  var a = e.locale, o = e.onError;
  n === void 0 && (n = {}), Intl.PluralRules || o(new G(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, F.MISSING_INTL_API));
  var s = Z(n, Ar);
  try {
    return t(a, s).select(r);
  } catch (i) {
    o(new Y("Error formatting plural.", i));
  }
  return "other";
}
var Or = ["numeric", "style"];
function Ur(e, t, r, n, a) {
  a === void 0 && (a = {}), n || (n = "second"), Intl.RelativeTimeFormat || e.onError(new G(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, F.MISSING_INTL_API));
  try {
    return function(o, s, i) {
      var c = o.locale, l = o.formats, u = o.onError;
      i === void 0 && (i = {});
      var d = i.format, p = !!d && Ne(l, "relative", d, u) || {};
      return s(c, Z(i, Or, p));
    }(e, t, a).format(r, n);
  } catch (o) {
    e.onError(new Y("Error formatting relative time.", o));
  }
  return String(r);
}
var Cr = ["localeMatcher", "style", "currency", "currencyDisplay", "unit", "unitDisplay", "useGrouping", "minimumIntegerDigits", "minimumFractionDigits", "maximumFractionDigits", "minimumSignificantDigits", "maximumSignificantDigits", "compactDisplay", "currencyDisplay", "currencySign", "notation", "signDisplay", "unit", "unitDisplay"];
function ot(e, t, r) {
  var n = e.locale, a = e.formats, o = e.onError;
  r === void 0 && (r = {});
  var s = r.format, i = s && Ne(a, "number", s, o) || {};
  return t(n, Z(r, Cr, i));
}
function Mr(e, t, r, n) {
  n === void 0 && (n = {});
  try {
    return ot(e, t, n).format(r);
  } catch (a) {
    e.onError(new C(O.FORMAT_ERROR, "Error formatting number.", a));
  }
  return String(r);
}
function kr(e, t, r, n) {
  n === void 0 && (n = {});
  try {
    return ot(e, t, n).formatToParts(r);
  } catch (a) {
    e.onError(new C(O.FORMAT_ERROR, "Error formatting number.", a));
  }
  return [];
}
function jr(e) {
  var t;
  e.defaultRichTextElements && typeof ((t = e.messages || {}) ? t[Object.keys(t)[0]] : void 0) == "string" && console.warn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function Dr(e, t) {
  var r = function(i) {
    i === void 0 && (i = { dateTime: {}, number: {}, message: {}, relativeTime: {}, pluralRules: {}, list: {}, displayNames: {} });
    var c = Intl.RelativeTimeFormat, l = Intl.ListFormat, u = Intl.DisplayNames, d = D(function() {
      for (var g, h = [], m = 0; m < arguments.length; m++) h[m] = arguments[m];
      return new ((g = Intl.DateTimeFormat).bind.apply(g, V([void 0], h)))();
    }, { cache: x(i.dateTime), strategy: H.variadic }), p = D(function() {
      for (var g, h = [], m = 0; m < arguments.length; m++) h[m] = arguments[m];
      return new ((g = Intl.NumberFormat).bind.apply(g, V([void 0], h)))();
    }, { cache: x(i.number), strategy: H.variadic }), b = D(function() {
      for (var g, h = [], m = 0; m < arguments.length; m++) h[m] = arguments[m];
      return new ((g = Intl.PluralRules).bind.apply(g, V([void 0], h)))();
    }, { cache: x(i.pluralRules), strategy: H.variadic });
    return { getDateTimeFormat: d, getNumberFormat: p, getMessageFormat: D(function(g, h, m, R) {
      return new rt(g, h, m, N({ formatters: { getNumberFormat: p, getDateTimeFormat: d, getPluralRules: b } }, R || {}));
    }, { cache: x(i.message), strategy: H.variadic }), getRelativeTimeFormat: D(function() {
      for (var g = [], h = 0; h < arguments.length; h++) g[h] = arguments[h];
      return new (c.bind.apply(c, V([void 0], g)))();
    }, { cache: x(i.relativeTime), strategy: H.variadic }), getPluralRules: b, getListFormat: D(function() {
      for (var g = [], h = 0; h < arguments.length; h++) g[h] = arguments[h];
      return new (l.bind.apply(l, V([void 0], g)))();
    }, { cache: x(i.list), strategy: H.variadic }), getDisplayNames: D(function() {
      for (var g = [], h = 0; h < arguments.length; h++) g[h] = arguments[h];
      return new (u.bind.apply(u, V([void 0], g)))();
    }, { cache: x(i.displayNames), strategy: H.variadic }) };
  }(t), n = N(N({}, gr), e), a = n.locale, o = n.defaultLocale, s = n.onError;
  return a ? !Intl.NumberFormat.supportedLocalesOf(a).length && s ? s(new De('Missing locale data for locale: "' + a + '" in Intl.NumberFormat. Using default locale: "' + o + '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')) : !Intl.DateTimeFormat.supportedLocalesOf(a).length && s && s(new De('Missing locale data for locale: "' + a + '" in Intl.DateTimeFormat. Using default locale: "' + o + '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')) : (s && s(new _r('"locale" was not configured, using "' + o + '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')), n.locale = n.defaultLocale || "en"), jr(n), N(N({}, n), { formatters: r, formatNumber: Mr.bind(null, n, r.getNumberFormat), formatNumberToParts: kr.bind(null, n, r.getNumberFormat), formatRelativeTime: Ur.bind(null, n, r.getRelativeTimeFormat), formatDate: br.bind(null, n, r.getDateTimeFormat), formatDateToParts: Tr.bind(null, n, r.getDateTimeFormat), formatTime: vr.bind(null, n, r.getDateTimeFormat), formatDateTimeRange: Rr.bind(null, n, r.getDateTimeFormat), formatTimeToParts: yr.bind(null, n, r.getDateTimeFormat), formatPlural: Ir.bind(null, n, r.getPluralRules), formatMessage: Er.bind(null, n, r), formatList: Nr.bind(null, n, r.getListFormat), formatListToParts: at.bind(null, n, r.getListFormat), formatDisplayName: Lr.bind(null, n, r.getDisplayNames) });
}
var it, Hr = { exports: {} };
typeof self < "u", it = function() {
  return function(e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = { i: n, l: !1, exports: {} };
      return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
    }
    return r.m = e, r.c = t, r.d = function(n, a, o) {
      r.o(n, a) || Object.defineProperty(n, a, { configurable: !1, enumerable: !0, get: o });
    }, r.n = function(n) {
      var a = n && n.__esModule ? function() {
        return n.default;
      } : function() {
        return n;
      };
      return r.d(a, "a", a), a;
    }, r.o = function(n, a) {
      return Object.prototype.hasOwnProperty.call(n, a);
    }, r.p = "", r(r.s = 7);
  }([function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.getRegionDefaultLocale = t.getCountryLanguages = t.createLocaleFromIMS = t.getAppNameFromURL = t.isUmbrellaRegionApp = t.getUmbrellaRegions = t.getAllLocales = t.stripUrl = t.langScript = t.normalize = t.priuse = t.regions = t.region = t.script = t.extlang = t.lang = t.findValueByKeyIgnoreCase = t.findKey = void 0;
    var n = function(f, E) {
      if (Array.isArray(f)) return f;
      if (Symbol.iterator in Object(f)) return function(v, S) {
        var I = [], k = !0, j = !1, z = void 0;
        try {
          for (var B, w = v[Symbol.iterator](); !(k = (B = w.next()).done) && (I.push(B.value), !S || I.length !== S); k = !0) ;
        } catch (M) {
          j = !0, z = M;
        } finally {
          try {
            !k && w.return && w.return();
          } finally {
            if (j) throw z;
          }
        }
        return I;
      }(f, E);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }, a = function(f) {
      if (f && f.__esModule) return f;
      var E = {};
      if (f != null) for (var v in f) Object.prototype.hasOwnProperty.call(f, v) && (E[v] = f[v]);
      return E.default = f, E;
    }(r(3)), o = l(r(67)), s = r(2), i = l(s), c = l(r(1));
    function l(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function u(f) {
      if (Array.isArray(f)) {
        for (var E = 0, v = Array(f.length); E < f.length; E++) v[E] = f[E];
        return v;
      }
      return Array.from(f);
    }
    var d = /^([a-zA-Z]{2})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?(?:-x-([a-zA-Z0-9]{1,8})(?=$))?$/, p = function(f) {
      return f.match(d) || [];
    }, b = function(f, E) {
      return Object.keys(f).find(function(v) {
        return E(f[v]);
      });
    }, g = function(f, E) {
      return E !== void 0 ? f[Object.keys(f).filter(function(v) {
        return v.toLowerCase() === E.toLowerCase();
      })[0]] : void 0;
    }, h = function(f) {
      var E = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], v = "", S = p(f);
      if (S.length > 0) if (S[3] !== void 0) v = E === !0 ? S[1] + "-" + S[3].charAt(0).toUpperCase() + S[3].slice(1) : S[1] + "-" + S[3];
      else if (S[1].toLowerCase() === "zh" && S[4] !== void 0) {
        var I = S[4].toLowerCase();
        v = ["tw", "hk", "mo"].includes(I) ? "zh-Hant" : "zh-Hans";
      } else v = S[1];
      return v;
    }, m = {};
    Object.keys(a).forEach(function(f) {
      var E = a[f];
      Object.keys(E).forEach(function(v) {
        var S = E[v];
        m[v] = S, m[S] === void 0 && (m[S] = S);
      });
    });
    var R = function() {
      return m;
    }, T = function(f) {
      return f.replace(/^https?:\/\//, "").replace(/^www\./, "");
    };
    t.findKey = b, t.findValueByKeyIgnoreCase = g, t.lang = function(f) {
      return p(f)[1] || "";
    }, t.extlang = function(f) {
      return p(f)[2] || "";
    }, t.script = function(f) {
      return p(f)[3] || "";
    }, t.region = function(f) {
      return p(f)[4] || "";
    }, t.regions = o.default, t.priuse = function(f) {
      return p(f)[5] || "";
    }, t.normalize = function(f, E) {
      var v = void 0;
      if (E) {
        var S = (0, c.default)(E, f);
        v = a[E][S];
      }
      return v || g(R(), f);
    }, t.langScript = h, t.stripUrl = T, t.getAllLocales = R, t.getUmbrellaRegions = function(f, E) {
      return b(s.umbrellaRegions, function(v) {
        return Array.isArray(v) ? v.includes(f.toLowerCase()) : v[["adobedotcom", "helpx"].includes(E) ? "adobedotcom" : "generic"].includes(f.toLowerCase());
      });
    }, t.isUmbrellaRegionApp = function(f) {
      return s.umbrellaRegionApp.includes(f);
    }, t.getAppNameFromURL = function(f) {
      var E = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      if (typeof f == "string" && f.length) {
        var v = T(f.trim().toLowerCase()), S = !0, I = !1, k = void 0;
        try {
          for (var j, z = i.default[Symbol.iterator](); !(S = (j = z.next()).done); S = !0) for (var B = n(j.value, 2), w = B[0], M = B[1], ce = M.production ? Array.isArray(M.production) ? M.production : [M.production] : [], fe = M.stage ? Array.isArray(M.stage) ? M.stage : [M.stage] : [], ee = [].concat(u(ce), u(fe)), X = 0; X < ee.length; X++) {
            var pe = ee[X], te = T(pe);
            if (v.indexOf(te) === 0) return E === !0 ? { name: w, appBaseURL: te.split("/")[0] } : w;
          }
        } catch (de) {
          I = !0, k = de;
        } finally {
          try {
            !S && z.return && z.return();
          } finally {
            if (I) throw k;
          }
        }
      }
    }, t.createLocaleFromIMS = function(f, E) {
      var v = !1, S = "en-US";
      if (typeof f == "string" && typeof E == "string" && E.length === 2) {
        var I = h(f, !0), k = E.toUpperCase(), j = o.default[k];
        j !== void 0 && (j.includes(I) ? v = !0 : I = j[0] || "en", S = I + "-" + k);
      }
      return { match: v, locale: S };
    }, t.getCountryLanguages = function(f) {
      var E = ["en"], v = typeof f == "string" ? o.default[f.toUpperCase()] || [] : E;
      return v.length ? v : E;
    }, t.getRegionDefaultLocale = function(f) {
      var E = void 0;
      if (typeof f == "string" && f.length === 2) {
        var v = f.toUpperCase();
        o.default[v] && o.default[v][0] && (E = o.default[v][0] + "-" + v);
      }
      return E;
    };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = function(o) {
      if (o && o.__esModule) return o;
      var s = {};
      if (o != null) for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (s[i] = o[i]);
      return s.default = o, s;
    }(r(3)), a = r(0);
    t.default = function o(s, i, c) {
      if (n[s] === void 0) return console.warn('[@intl/adobe-locales] App "' + s + '" is not supported. Please refer to https://git.corp.adobe.com/intl/adobe-locales#supported-apps'), "";
      if (typeof i == "string" && i.substring(0, 2) === "zz") {
        var l = o(s, "en-US");
        return l.includes("-") ? "zz-ZZ" : l.includes("_") ? "zz_ZZ" : "zz";
      }
      var u = void 0;
      if (i && n[s][i] !== void 0) u = i;
      else {
        var d = (0, a.getAllLocales)();
        if (i && ((0, a.lang)(i) !== "" || d[i] !== void 0)) {
          var p = (0, a.findValueByKeyIgnoreCase)(d, i);
          if (p === void 0 && (p = i.length === 2 ? (0, a.getRegionDefaultLocale)(i) || i : i.includes("_") ? i.replace(/_/g, "-") : i), (u = (0, a.findKey)(n[s], function(f) {
            return f === p;
          })) === void 0 && (0, a.isUmbrellaRegionApp)(s)) {
            var b = (0, a.getUmbrellaRegions)((0, a.region)(i), s);
            if (b) {
              var g = (0, a.lang)(i) + "-x-" + b.toUpperCase(), h = i.slice(0, -2) + b.toUpperCase();
              (u = (0, a.findKey)(n[s], function(f) {
                return f === g || f === h;
              })) === void 0 && n[s][b] !== void 0 && (u = b);
            }
          }
          if (u === void 0 && (0, a.script)(p) !== "") {
            var m = p.substr(0, 7).toLowerCase();
            u = (0, a.findKey)(n[s], function(f) {
              return f.substr(0, 7).toLowerCase() === m;
            });
          }
          if (u === void 0) {
            var R = p.substr(0, 2).toLowerCase();
            u = (0, a.findKey)(n[s], function(f) {
              return f.substr(0, 2).toLowerCase() === R;
            });
          }
          if (u === void 0) {
            var T = p.split("-").pop().toLowerCase();
            u = (0, a.findKey)(n[s], function(f) {
              return f.substr(f.length - T.length, T.length).toLowerCase() === T;
            });
          }
        }
        u === void 0 && c !== void 0 && (u = (0, a.findKey)(n[s], function(f) {
          return f === c || f === d[c];
        }));
      }
      return s === "stock" && u === "us" && (u = ""), u || "";
    };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = new Map(Object.entries({ academic_verification: { stage: "https://commerce-stg.adobe.com/academic-verification", production: "https://commerce.adobe.com/academic-verification" }, acrobat_plan: { stage: "https://stage.acrobat.adobe.com/proxy/pricing", production: "https://acrobat.adobe.com/proxy/pricing" }, acrobat_web: { stage: "https://stage.acrobat.adobe.com", production: "https://acrobat.adobe.com" }, adobeaccount: { stage: "https://stage.account.adobe.com", production: "https://account.adobe.com" }, adminconsole: { stage: "https://stage.adminconsole.adobe.com", production: "https://adminconsole.adobe.com" }, assets: { stage: "https://assets-stage.adobecc.com", production: "https://assets.adobe.com" }, behance: { stage: "https://net.s2stagehance.com", production: "https://www.behance.net" }, spice: { stage: "https://stage.projectspice.corp.adobe.com", production: "https://projectspice.adobe.com" }, cchome: { stage: "https://stage.creativecloud.adobe.com", production: "https://creativecloud.adobe.com" }, color: { stage: "https://colorweb-stage.adobeku.com", production: "https://color.adobe.com" }, community: { stage: "https://community-stg.adobe.com", production: "https://community.adobe.com" }, creativecloudapp: { stage: "https://stage.ccmui.adobe.com", production: "https://creative.adobe.com" }, dcweb: { stage: "https://dc.stage.acrobat.com", production: "https://documentcloud.adobe.com" }, experiencecloud: { stage: "https://experiencecloud-stage.adobe.com", production: "https://experiencecloud.adobe.com" }, firefly: { stage: "https://firefly-stage.corp.adobe.com", production: "https://firefly.adobe.com" }, firefly_nonprod: { stage: "https://firefly-stage.corp.adobe.com", dev: "https://firefly-dev.corp.adobe.com" }, frameio: { stage: "https://support.frame.io", production: "https://support.frame.io" }, fonts: { stage: "https://fonts-relstage.adobe.com", production: "https://fonts.adobe.com" }, helpx: { stage: "https://helpx.stage.adobe.com", production: "https://helpx.adobe.com" }, ims: { stage: "https://ims-na1-stg1.adobelogin.com", production: "https://adobeid-na1.services.adobe.com" }, lightroom: { stage: "https://stage.adobelr.com", production: "https://lightroom.adobe.com" }, mini_plans: { stage: "https://www.stage.adobe.com/mini-plans", production: "https://www.adobe.com/mini-plans" }, ngl: { stage: "https://workflow-stage.licenses.adobe.com", production: "https://workflow.licenses.adobe.com" }, psweb: { stage: "https://stage.photoshop.adobe.com", production: "https://photoshop.adobe.com" }, portfolio: { stage: "https://portfolio.ccpsx.com", production: "https://portfolio.adobe.com" }, projectx: { stage: "https://stage.projectx.corp.adobe.com", production: ["https://preview.projectx.corp.adobe.com", "https://projectx.corp.adobe.com", "https://new.express.adobe.com"], regions: ["AU", "BR", "CO", "DE", "ES", "FR", "ID", "IN", "IT", "JP", "KR", "MX", "TH", "GB", "US", "ZZ"] }, redemption_ui: { stage: "https://redeem-stg.adobe.com", production: "https://redeem.adobe.com" }, stock: { stage: "https://primary.stock.stage.adobe.com", production: "https://stock.adobe.com" }, stock_contributor: { stage: "https://contributor.stock.stage.adobe.com", production: "https://contributor.stock.adobe.com" }, spark: { stage: "https://express-stage.adobe.com", production: ["https://spark.adobe.com", "https://express.adobe.com"] }, s3diweb: { stage: ["https://dev.substance3d.adobe.com/assets", "https://dev.substance3d.adobe.com/community-assets", "https://dev.substance3d.adobe.com/tutorials"], production: "https://substance3d.adobe.com" }, s3diwebviewer: { stage: ["https://rte-web-viewer-develop.dev.substance3d.io", "https://rte-web-viewer-beehive.dev.substance3d.io"], production: ["https://rte-web-viewer.substance3d.com"] }, commerce_ui: { stage: "https://commerce-stg.adobe.com", production: "https://commerce.adobe.com" }, unifiedcheckout: { stage: "https://commerce-stg.adobe.com", production: "https://commerce.adobe.com" }, unfurl: { stage: "N/A", production: "N/A" }, xd: { stage: "https://stage.xd.adobe.com", production: "https://xd.adobe.com" }, adobedotcom: { stage: "https://www.stage.adobe.com", production: "https://www.adobe.com" } }));
    t.urlApp = ["adobedotcom", "helpx", "spark", "stock_contributor", "stock", "accountmanagement", "creativecloudapp", "ngl", "color", "mini_plans", "frameio"], t.langParamApp = ["adobeaccount", "redemption_ui", "unifiedcheckout", "academic_verification", "community", "psweb", "s3diweb", "s3diwebviewer"], t.umbrellaRegionApp = ["adobedotcom", "helpx", "globalnav", "ims", "acrobat_plan", "ngl", "jarvis", "mini_plans"], t.umbrellaRegions = { africa: { generic: ["africa", "ao", "bf", "bi", "bj", "bw", "cd", "cf", "cg", "ci", "cm", "cv", "dj", "er", "et", "ga", "gh", "gm", "gn", "gq", "gw", "ke", "km", "lr", "ls", "mg", "ml", "mu", "mw", "mz", "na", "ne", "ng", "rw", "sc", "sd", "sl", "sn", "so", "st", "sz", "td", "tg", "tz", "ug", "za", "zm", "zw"], adobedotcom: ["africa", "ao", "bf", "bi", "bj", "bw", "cd", "cf", "cg", "ci", "cm", "cv", "dj", "er", "et", "ga", "gh", "gm", "gn", "gq", "gw", "ke", "km", "lr", "ls", "mg", "ml", "mu", "mw", "mz", "na", "ne", "rw", "sc", "sd", "sl", "sn", "so", "st", "sz", "td", "tg", "tz", "ug", "za", "zm", "zw"] }, cis: ["cis", "by", "kg", "kz", "tj", "uz"], la: { generic: ["la", "ar", "bl", "bo", "br", "bz", "cl", "co", "cr", "cu", "do", "ec", "fk", "gf", "gt", "gy", "hn", "ht", "mf", "mq", "ni", "pa", "pe", "pr", "py", "sr", "sv", "uy", "ve", "tt"], adobedotcom: ["la", "bl", "bo", "br", "bz", "cl", "cr", "cu", "do", "fk", "gf", "gy", "hn", "ht", "mf", "mq", "ni", "pa", "py", "sr", "sv", "uy", "ve", "tt"] }, mena: { generic: ["mena", "ae", "bh", "dz", "eg", "jo", "kw", "lb", "ma", "om", "qa", "sa", "tn", "ye", "iq", "ly", "mr"], adobedotcom: ["mena", "ae", "bh", "dz", "jo", "lb", "ma", "om", "sa", "tn", "ye", "iq", "ly", "mr"] }, sea: { generic: ["sea", "id", "my", "ph", "sg", "th", "vn", "lk"], adobedotcom: ["sea", "sg", "lk"] }, hk: ["mo"], ie: ["hr"] }, t.default = n;
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(8);
    Object.defineProperty(t, "academic_verification", { enumerable: !0, get: function() {
      return _(n).default;
    } });
    var a = r(9);
    Object.defineProperty(t, "adminconsole", { enumerable: !0, get: function() {
      return _(a).default;
    } });
    var o = r(10);
    Object.defineProperty(t, "adobeaccount", { enumerable: !0, get: function() {
      return _(o).default;
    } });
    var s = r(11);
    Object.defineProperty(t, "adobedotcom", { enumerable: !0, get: function() {
      return _(s).default;
    } });
    var i = r(12);
    Object.defineProperty(t, "acrobat_plan", { enumerable: !0, get: function() {
      return _(i).default;
    } });
    var c = r(13);
    Object.defineProperty(t, "acrobat_web", { enumerable: !0, get: function() {
      return _(c).default;
    } });
    var l = r(14);
    Object.defineProperty(t, "acrs", { enumerable: !0, get: function() {
      return _(l).default;
    } });
    var u = r(15);
    Object.defineProperty(t, "assets", { enumerable: !0, get: function() {
      return _(u).default;
    } });
    var d = r(16);
    Object.defineProperty(t, "behance", { enumerable: !0, get: function() {
      return _(d).default;
    } });
    var p = r(17);
    Object.defineProperty(t, "spice", { enumerable: !0, get: function() {
      return _(p).default;
    } }), Object.defineProperty(t, "quick_actions", { enumerable: !0, get: function() {
      return _(p).default;
    } });
    var b = r(18);
    Object.defineProperty(t, "squirrel", { enumerable: !0, get: function() {
      return _(b).default;
    } });
    var g = r(4);
    Object.defineProperty(t, "cchome", { enumerable: !0, get: function() {
      return _(g).default;
    } });
    var h = r(19);
    Object.defineProperty(t, "cchome_learn", { enumerable: !0, get: function() {
      return _(h).default;
    } });
    var m = r(20);
    Object.defineProperty(t, "cchome_leftnav", { enumerable: !0, get: function() {
      return _(m).default;
    } });
    var R = r(21);
    Object.defineProperty(t, "cclibrary", { enumerable: !0, get: function() {
      return _(R).default;
    } });
    var T = r(22);
    Object.defineProperty(t, "ccsearch", { enumerable: !0, get: function() {
      return _(T).default;
    } });
    var f = r(23);
    Object.defineProperty(t, "color", { enumerable: !0, get: function() {
      return _(f).default;
    } });
    var E = r(24);
    Object.defineProperty(t, "comments", { enumerable: !0, get: function() {
      return _(E).default;
    } }), Object.defineProperty(t, "commerce_ui", { enumerable: !0, get: function() {
      return _(n).default;
    } });
    var v = r(25);
    Object.defineProperty(t, "community", { enumerable: !0, get: function() {
      return _(v).default;
    } });
    var S = r(26);
    Object.defineProperty(t, "creativecloudapp", { enumerable: !0, get: function() {
      return _(S).default;
    } });
    var I = r(27);
    Object.defineProperty(t, "dva_voice", { enumerable: !0, get: function() {
      return _(I).default;
    } }), Object.defineProperty(t, "dcweb", { enumerable: !0, get: function() {
      return _(c).default;
    } });
    var k = r(28);
    Object.defineProperty(t, "editbilling", { enumerable: !0, get: function() {
      return _(k).default;
    } });
    var j = r(29);
    Object.defineProperty(t, "experiencecloud", { enumerable: !0, get: function() {
      return _(j).default;
    } });
    var z = r(30);
    Object.defineProperty(t, "firefly", { enumerable: !0, get: function() {
      return _(z).default;
    } });
    var B = r(31);
    Object.defineProperty(t, "firefly_nonprod", { enumerable: !0, get: function() {
      return _(B).default;
    } });
    var w = r(32);
    Object.defineProperty(t, "fonts", { enumerable: !0, get: function() {
      return _(w).default;
    } });
    var M = r(33);
    Object.defineProperty(t, "font_picker", { enumerable: !0, get: function() {
      return _(M).default;
    } });
    var ce = r(34);
    Object.defineProperty(t, "frameio", { enumerable: !0, get: function() {
      return _(ce).default;
    } });
    var fe = r(35);
    Object.defineProperty(t, "globalnav", { enumerable: !0, get: function() {
      return _(fe).default;
    } }), Object.defineProperty(t, "helpx", { enumerable: !0, get: function() {
      return _(s).default;
    } });
    var ee = r(36);
    Object.defineProperty(t, "ims", { enumerable: !0, get: function() {
      return _(ee).default;
    } });
    var X = r(37);
    Object.defineProperty(t, "lightroom", { enumerable: !0, get: function() {
      return _(X).default;
    } });
    var pe = r(38);
    Object.defineProperty(t, "jarvis", { enumerable: !0, get: function() {
      return _(pe).default;
    } });
    var te = r(39);
    Object.defineProperty(t, "mcs", { enumerable: !0, get: function() {
      return _(te).default;
    } });
    var de = r(40);
    Object.defineProperty(t, "mini_plans_photoshop_lightroom_start_trial", { enumerable: !0, get: function() {
      return _(de).default;
    } });
    var dt = r(41);
    Object.defineProperty(t, "mini_plans", { enumerable: !0, get: function() {
      return _(dt).default;
    } });
    var ht = r(42);
    Object.defineProperty(t, "mt", { enumerable: !0, get: function() {
      return _(ht).default;
    } });
    var _t = r(43);
    Object.defineProperty(t, "ngl", { enumerable: !0, get: function() {
      return _(_t).default;
    } });
    var mt = r(44);
    Object.defineProperty(t, "panel_licensing", { enumerable: !0, get: function() {
      return _(mt).default;
    } });
    var gt = r(45);
    Object.defineProperty(t, "psweb", { enumerable: !0, get: function() {
      return _(gt).default;
    } });
    var Et = r(46);
    Object.defineProperty(t, "portfolio", { enumerable: !0, get: function() {
      return _(Et).default;
    } });
    var bt = r(47);
    Object.defineProperty(t, "projectx", { enumerable: !0, get: function() {
      return _(bt).default;
    } });
    var vt = r(48);
    Object.defineProperty(t, "publiclinks", { enumerable: !0, get: function() {
      return _(vt).default;
    } });
    var Rt = r(49);
    Object.defineProperty(t, "react_spectrum", { enumerable: !0, get: function() {
      return _(Rt).default;
    } });
    var Tt = r(50);
    Object.defineProperty(t, "redemption_ui", { enumerable: !0, get: function() {
      return _(Tt).default;
    } });
    var yt = r(51);
    Object.defineProperty(t, "sharesheet", { enumerable: !0, get: function() {
      return _(yt).default;
    } });
    var St = r(52);
    Object.defineProperty(t, "spark", { enumerable: !0, get: function() {
      return _(St).default;
    } });
    var Lt = r(53);
    Object.defineProperty(t, "stock", { enumerable: !0, get: function() {
      return _(Lt).default;
    } });
    var Pt = r(54);
    Object.defineProperty(t, "stock_api", { enumerable: !0, get: function() {
      return _(Pt).default;
    } });
    var Nt = r(55);
    Object.defineProperty(t, "stock_contributor", { enumerable: !0, get: function() {
      return _(Nt).default;
    } });
    var At = r(56);
    Object.defineProperty(t, "s3diweb", { enumerable: !0, get: function() {
      return _(At).default;
    } });
    var It = r(57);
    Object.defineProperty(t, "s3diwebviewer", { enumerable: !0, get: function() {
      return _(It).default;
    } }), Object.defineProperty(t, "switchplan_app", { enumerable: !0, get: function() {
      return _(o).default;
    } });
    var Ot = r(58);
    Object.defineProperty(t, "timeline", { enumerable: !0, get: function() {
      return _(Ot).default;
    } });
    var Ut = r(59);
    Object.defineProperty(t, "unfurl", { enumerable: !0, get: function() {
      return _(Ut).default;
    } }), Object.defineProperty(t, "unifiedcheckout", { enumerable: !0, get: function() {
      return _(n).default;
    } });
    var Ct = r(60);
    Object.defineProperty(t, "unifiedcheckout_v1", { enumerable: !0, get: function() {
      return _(Ct).default;
    } });
    var Mt = r(61);
    Object.defineProperty(t, "unifiedpanel", { enumerable: !0, get: function() {
      return _(Mt).default;
    } });
    var kt = r(62);
    Object.defineProperty(t, "uss", { enumerable: !0, get: function() {
      return _(kt).default;
    } });
    var jt = r(63);
    Object.defineProperty(t, "utilitynav", { enumerable: !0, get: function() {
      return _(jt).default;
    } });
    var Dt = r(64);
    Object.defineProperty(t, "ututs", { enumerable: !0, get: function() {
      return _(Dt).default;
    } });
    var Ht = r(65);
    Object.defineProperty(t, "xd", { enumerable: !0, get: function() {
      return _(Ht).default;
    } });
    var Ft = r(66);
    function _(re) {
      return re && re.__esModule ? re : { default: re };
    }
    Object.defineProperty(t, "_supplement", { enumerable: !0, get: function() {
      return _(Ft).default;
    } });
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n, a = r(1), o = (n = a) && n.__esModule ? n : { default: n }, s = r(0);
    t.default = function(i, c, l) {
      typeof i == "string" && (i = i.replace(/-/g, "_"));
      var u = (0, s.createLocaleFromIMS)(c, l), d = u.locale, p = u.match, b = (0, o.default)(i, d);
      return i !== "mini_plans" && i !== "mini_plans_photoshop_lightroom_start_trial" || (p = p && d === (0, s.normalize)(b, i)), { match: p, locale: b };
    };
  }, function(e, t, r) {
    (function(n) {
      Object.defineProperty(t, "__esModule", { value: !0 });
      var a, o = r(2), s = r(0), i = r(1), c = (a = i) && a.__esModule ? a : { default: a };
      t.default = function(l, u) {
        try {
          if (typeof l != "string" || typeof u != "string") throw Error('expect "url" and "locale" to be string.');
          if ((l = l.trim()).toLowerCase().includes("adobe.com/go/")) return l;
          var d = l, p = (0, s.getAppNameFromURL)(l, !0), b = p.name, g = p.appBaseURL;
          if (b === void 0) throw Error('this app is not supported yet: "' + l + '"');
          var h = (0, c.default)(b, u);
          if (h) {
            var m = (0, s.getAllLocales)();
            if (o.urlApp.includes(b)) {
              h !== "en" && h !== "us" && h !== "en-US" || (h = "");
              var R = g + "/(.*?)(?=/|$)", T = (l.match(R) || [])[1];
              T !== void 0 && m[T] !== void 0 ? d = l.replace(g + "/" + T, h === "" ? g : g + "/" + h) : (h !== "" && (d = l.replace(g, g + "/" + h)), b === "helpx" && l.includes(".ug.html") && (d = d.replace(".html/", ".html/" + h + "/")));
            } else {
              var f = o.langParamApp.includes(b) ? b === "community" ? "profile.language" : "lang" : "locale", E = new RegExp("(" + f + "=)(.*?)(?=&|$)");
              d = (l.match(E) || [])[2] !== void 0 ? l.replace(E, "$1" + h) : l + (l.includes("?") ? "&" : "?") + f + "=" + h;
            }
          }
          return d;
        } catch (v) {
          n.env.NODE_ENV === "development" && console.error("[getLocalizedURL] Error: " + v.message);
        }
        return l;
      };
    }).call(t, r(70));
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = r(1);
    Object.defineProperty(t, "getAppLocale", { enumerable: !0, get: function() {
      return d(n).default;
    } });
    var a = r(68);
    Object.defineProperty(t, "getAppLocales", { enumerable: !0, get: function() {
      return d(a).default;
    } });
    var o = r(69);
    Object.defineProperty(t, "getAppRegions", { enumerable: !0, get: function() {
      return d(o).default;
    } });
    var s = r(5);
    Object.defineProperty(t, "getAppLocaleFromIMS", { enumerable: !0, get: function() {
      return d(s).default;
    } });
    var i = r(6);
    Object.defineProperty(t, "getLocalizedURL", { enumerable: !0, get: function() {
      return d(i).default;
    } });
    var c = r(71);
    Object.defineProperty(t, "getLocalizedURLFromIMS", { enumerable: !0, get: function() {
      return d(c).default;
    } });
    var l = r(72);
    Object.defineProperty(t, "parseLocaleParam", { enumerable: !0, get: function() {
      return d(l).default;
    } });
    var u = r(0);
    function d(p) {
      return p && p.__esModule ? p : { default: p };
    }
    Object.keys(u).forEach(function(p) {
      p !== "default" && p !== "__esModule" && Object.defineProperty(t, p, { enumerable: !0, get: function() {
        return u[p];
      } });
    });
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { bg: "bg-BG", cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", el: "el-GR", es: "es-ES", et: "et-EE", fi: "fi-FI", fr: "fr-FR", hu: "hu-HU", id: "id-ID", it: "it-IT", ja: "ja-JP", ko: "ko-KR", lt: "lt-LT", lv: "lv-LV", ms: "ms-MY", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ro: "ro-RO", ru: "ru-RU", sk: "sk-SK", sl: "sl-SI", sv: "sv-SE", th: "th-TH", tr: "tr-TR", uk: "uk-UA", vi: "vi-VN", "zh-hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", "zh-cn": "zh-Hans-CN", "zh-tw": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { ar: "ar-AE", bg: "bg-BG", cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", el: "el-GR", es: "es-ES", et: "et-EE", fi: "fi-FI", fr: "fr-FR", id: "id-ID", he: "he-IL", hu: "hu-HU", it: "it-IT", ja: "ja-JP", ko: "ko-KR", lt: "lt-LT", lv: "lv-LV", ms: "ms-MY", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ro: "ro-RO", ru: "ru-RU", sk: "sk-SK", sl: "sl-SI", sv: "sv-SE", th: "th-TH", tr: "tr-TR", uk: "uk-UA", vi: "vi-VN", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { mena_ar: "ar-x-MENA", ae_ar: "ar-AE", eg_ar: "ar-EG", sa_ar: "ar-SA", kw_ar: "ar-KW", qa_ar: "ar-QA", bg: "bg-BG", cz: "cs-CZ", dk: "da-DK", de: "de-DE", at: "de-AT", ch_de: "de-CH", lu_de: "de-LU", ph_fil: "fil-PH", us: "en-US", ae_en: "en-AE", au: "en-AU", be_en: "en-BE", ca: "en-CA", cy_en: "en-CY", uk: "en-GB", gr_en: "en-GR", eg_en: "en-EG", hk_en: "en-HK", ie: "en-IE", il_en: "en-IL", in: "en-IN", kw_en: "en-KW", lu_en: "en-LU", mt: "en-MT", ng: "en-NG", nz: "en-NZ", sa_en: "en-SA", sg: "en-SG", th_en: "en-TH", ph_en: "en-PH", qa_en: "en-QA", id_en: "en-ID", my_en: "en-MY", vn_en: "en-VN", africa: "en-x-AFRICA", cis_en: "en-x-CIS", mena_en: "en-x-MENA", sea: "en-x-SEA", ec: "es-EC", es: "es-ES", gt: "es-GT", mx: "es-MX", cl: "es-CL", ar: "es-AR", co: "es-CO", pe: "es-PE", pr: "es-PR", la: "es-x-LA", ee: "et-EE", fi: "fi-FI", fr: "fr-FR", be_fr: "fr-BE", ca_fr: "fr-CA", ch_fr: "fr-CH", lu_fr: "fr-LU", il_he: "he-IL", hu: "hu-HU", in_hi: "hi-IN", id_id: "id-ID", it: "it-IT", ch_it: "it-CH", jp: "ja-JP", kr: "ko-KR", lt: "lt-LT", lv: "lv-LV", my_ms: "ms-MY", no: "nb-NO", nl: "nl-NL", be_nl: "nl-BE", pl: "pl-PL", pt: "pt-PT", br: "pt-BR", ro: "ro-RO", ru: "ru-RU", cis_ru: "ru-x-CIS", sk: "sk-SK", si: "sl-SI", se: "sv-SE", th_th: "th-TH", tr: "tr-TR", ua: "uk-UA", vn_vi: "vi-VN", cn: "zh-Hans-CN", tw: "zh-Hant-TW", hk_zh: "zh-Hant-HK" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "en-GB": "en-GB", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "hu-HU": "hu-HU", "sk-SK": "sk-SK", "sl-SI": "sl-SI", "uk-UA": "uk-UA", "hr-HR": "hr-HR", "ro-RO": "ro-RO", "ca-ES": "ca-ES", "eu-ES": "eu-ES", "zh-CN": "zh-Hans-CN", "zh-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "en-GB": "en-GB", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "zh-CN": "zh-Hans-CN", "zh-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "zh-CN": "zh-Hans-CN", "zh-TW": "zh-Hant-TW", "eu-ES": "eu-ES", "id-ID": "id-ID", "ms-MY": "ms-MY", "th-TH": "th-TH", "vi-VN": "vi-VN", "hr-HR": "hr-HR", "sl-SI": "sl-SI", "sk-SK": "sk-SK", "uk-UA": "uk-UA", "hu-HU": "hu-HU", "is-IS": "is-IS", "cy-GB": "cy-GB" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "zh-CN": "zh-Hans-CN", "zh-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "cy-GB": "cy-GB", "da-DK": "da-DK", "de-DE": "de-DE", "en-GB": "en-GB", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "uk-UA": "uk-UA", "zh-Hans-CN": "zh-Hans-CN", "zh-Hant-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cy-GB": "cy-GB", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pt-BR": "pt-BR", "sv-SE": "sv-SE", "zh-Hans-CN": "zh-Hans-CN", "zh-Hant-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n, a = Object.assign || function(i) {
      for (var c = 1; c < arguments.length; c++) {
        var l = arguments[c];
        for (var u in l) Object.prototype.hasOwnProperty.call(l, u) && (i[u] = l[u]);
      }
      return i;
    }, o = r(4), s = a({}, ((n = o) && n.__esModule ? n : { default: n }).default, { hu: "hu-HU", uk: "uk-UA" });
    t.default = s;
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n, a = Object.assign || function(i) {
      for (var c = 1; c < arguments.length; c++) {
        var l = arguments[c];
        for (var u in l) Object.prototype.hasOwnProperty.call(l, u) && (i[u] = l[u]);
      }
      return i;
    }, o = r(4), s = a({}, ((n = o) && n.__esModule ? n : { default: n }).default, { cy: "cy-GB", ms: "ms-MY", id: "id-ID", hu: "hu-HU", th: "th-TH", uk: "uk-UA" });
    t.default = s;
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs_CZ: "cs-CZ", cy_GB: "cy-GB", da_DK: "da-DK", de_DE: "de-DE", en_US: "en-US", es_ES: "es-ES", es_MX: "es-MX", fi_FI: "fi-FI", fr_FR: "fr-FR", fr_CA: "fr-CA", fr_MA: "fr-MA", hu_HU: "hu-HU", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", nb_NO: "nb-NO", nl_NL: "nl-NL", pl_PL: "pl-PL", pt_BR: "pt-BR", ru_RU: "ru-RU", sv_SE: "sv-SE", tr_TR: "tr-TR", uk_UA: "uk-UA", zh_CN: "zh-Hans-CN", zh_TW: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", hu: "hu-HU", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", uk: "uk-UA", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", zh: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", cy: "cy-GB", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", hu: "hu-HU", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", uk: "uk-UA", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { de: "de-DE", en: "en-US", es: "es-ES", fr: "fr-FR", ja: "ja-JP", ko: "ko-KR", pt: "pt-BR" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", "zh-cn": "zh-Hans-CN", "zh-tw": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "da-dk": "da-DK", "de-de": "de-DE", "en-us": "en-US", "en-gb": "en-GB", "es-es": "es-ES", "fr-fr": "fr-FR", "hi-in": "hi-IN", "it-it": "it-IT", "ja-jp": "ja-JP", "ko-kr": "ko-KR", "pt-br": "pt-BR", "pt-pt": "pt-PT", "nb-no": "nb-NO", "nl-nl": "nl-NL", "sv-se": "sv-SE", "ru-ru": "ru-RU", "cmn-hans": "zh-Hans-CN", "cmn-hant": "zh-Hant-TW", "zh-hk": "zh-Hant-HK" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { ar: "ar-AE", bg: "bg-BG", cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", el: "el-GR", et: "et-EE", fi: "fi-FI", fr: "fr-FR", he: "he-IL", hu: "hu-HU", id: "id-ID", it: "it-IT", ja: "ja-JP", ko: "ko-KR", lt: "lt-LT", lv: "lv-LV", ms: "ms-MY", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ro: "ro-RO", ru: "ru-RU", sk: "sk-SK", sl: "sl-SI", sv: "sv-SE", th: "th-TH", tr: "tr-TR", uk: "uk-UA", vi: "vi-VN", "zh-hans": "zh-Hans-CN", "zh-hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { de: "de-DE", en: "en-US", es: "es-ES", fr: "fr-FR", it: "it-IT", ja: "ja-JP", "ko-kr": "ko-KR", "pt-br": "pt-BR", "zh-cn": "zh-Hans-CN", "zh-tw": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "hu-HU": "hu-HU", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "uk-UA": "uk-UA", "zh-Hans-CN": "zh-Hans-CN", "zh-Hant-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "hu-HU": "hu-HU", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-BL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "uk-UA": "uk-UA", "zh-Hans-CN": "zh-Hans-CN", "zh-Hant-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pt-BR": "pt-BR", "sv-SE": "sv-SE", "ru-RU": "ru-RU", "zh-CN": "zh-Hans-CN", "zh-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "cy-GB": "cy-GB", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "hu-HU": "hu-HU", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "uk-UA": "uk-UA", "zh-CN": "zh-Hans-CN", "zh-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { de: "de-DE", en: "en-US", es: "es-ES", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", ru: "ru-RU", "pt-BR": "pt-BR", "zh-CN": "zh-Hans-CN" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { mena_ar: "ar-x-MENA", ae_ar: "ar-AE", sa_ar: "ar-SA", bg: "bg-BG", cz: "cs-CZ", dk: "da-DK", de: "de-DE", at: "de-AT", ch_de: "de-CH", lu_de: "de-LU", us: "en-US", ae_en: "en-AE", au: "en-AU", be_en: "en-BE", ca: "en-CA", cy_en: "en-CY", uk: "en-GB", gr_en: "en-GR", hk_en: "en-HK", ie: "en-IE", il_en: "en-IL", in: "en-IN", lu_en: "en-LU", mt: "en-MT", nz: "en-NZ", sa_en: "en-SA", sg: "en-SG", th_en: "en-TH", africa: "en-x-AFRICA", cis_en: "en-x-CIS", mena_en: "en-x-MENA", sea: "en-x-SEA", es: "es-ES", mx: "es-MX", cl: "es-CL", la: "es-x-LA", ee: "et-EE", fi: "fi-FI", fr: "fr-FR", be_fr: "fr-BE", ca_fr: "fr-CA", ch_fr: "fr-CH", lu_fr: "fr-LU", il_he: "he-IL", hu: "hu-HU", it: "it-IT", ch_it: "it-CH", jp: "ja-JP", kr: "ko-KR", lt: "lt-LT", lv: "lv-LV", no: "nb-NO", nl: "nl-NL", be_nl: "nl-BE", pl: "pl-PL", pt: "pt-PT", br: "pt-BR", ro: "ro-RO", ru: "ru-RU", cis_ru: "ru-x-CIS", sk: "sk-SK", si: "sl-SI", se: "sv-SE", th_th: "th-TH", tr: "tr-TR", ua: "uk-UA", cn: "zh-Hans-CN", tw: "zh-Hant-TW", hk_zh: "zh-Hant-HK" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { bg_BG: "bg-BG", cs_CZ: "cs-CZ", da_DK: "da-DK", de_DE: "de-DE", en_US: "en-US", en_AE: "en-AE", en_GB: "en-GB", en_IL: "en-IL", en_XM: "en-x-MENA", es_ES: "es-ES", es_LA: "es-x-LA", es_MX: "es-MX", es_NA: "es-x-NA", et_EE: "et-EE", fi_FI: "fi-FI", fr_FR: "fr-FR", fr_CA: "fr-CA", fr_MA: "fr-MA", fr_XM: "fr-x-MENA", hr_HR: "hr-HR", hu_HU: "hu-HU", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", lt_LT: "lt-LT", lv_LV: "lv-LV", nb_NO: "nb-NO", nl_NL: "nl-NL", pl_PL: "pl-PL", pt_BR: "pt-BR", ro_RO: "ro-RO", ru_RU: "ru-RU", sk_SK: "sk-SK", sl_SI: "sl-SI", sr_RS: "sr-RS", sr_SP: "sr-RS", sv_SE: "sv-SE", tr_TR: "tr-TR", uk_UA: "uk-UA", zh_HANS: "zh-Hans-CN", zh_CN: "zh-Hans-CN", zh_HANT: "zh-Hant-TW", zh_TW: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "de-DE": "de-DE", "en-US": "en-US", "en-GB": "en-GB", "es-ES": "es-ES", "es-MX": "es-MX", "fr-FR": "fr-FR", "fr-CA": "fr-CA", "hu-HU": "hu-HU", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nl-NL": "nl-NL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "th-TH": "th-TH", "uk-UA": "uk-UA", "zh-CN": "zh-Hans-CN", "zh-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { ar_MENA: "ar-x-MENA", bg_BG: "bg-BG", cs_CZ: "cs-CZ", da_DK: "da-DK", de_DE: "de-DE", de_AT: "de-AT", de_CH: "de-CH", de_LU: "de-LU", en_US: "en-US", en_AU: "en-AU", en_BE: "en-BE", en_CA: "en-CA", en_CY: "en-CY", en_GB: "en-GB", en_GR: "en-GR", en_HK: "en-HK", en_IE: "en-IE", en_IL: "en-IL", en_IN: "en-IN", en_LU: "en-LU", en_MENA: "en-x-MENA", en_MT: "en-MT", en_NZ: "en-NZ", en_SEA: "en-x-SEA", en_ZA: "en-x-AFRICA", es_ES: "es-ES", es_LA: "es-x-LA", es_MX: "es-MX", et_EE: "et-EE", fi_FI: "fi-FI", fr_FR: "fr-FR", fr_BE: "fr-BE", fr_CA: "fr-CA", fr_CH: "fr-CH", fr_LU: "fr-LU", he_IL: "he-IL", hu_HU: "hu-HU", it_CH: "it-CH", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", lt_LT: "lt-LT", lv_LV: "lv-LV", nb_NO: "nb-NO", nl_BE: "nl-BE", nl_NL: "nl-NL", pl_PL: "pl-PL", pt_BR: "pt-BR", pt_PT: "pt-PT", ro_RO: "ro-RO", ru_RU: "ru-RU", sk_SK: "sk-SK", sl_SI: "sl-SI", sv_SE: "sv-SE", tr_TR: "tr-TR", uk_UA: "uk-UA", zh_CN: "zh-Hans-CN", zh_TW: "zh-Hant-TW", zh_HK: "zh-Hant-HK" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { ar_AE: "ar-AE", bg_BG: "bg-BG", cs_CZ: "cs-CZ", da_DK: "da-DK", de_DE: "de-DE", en_US: "en-US", en_GB: "en-GB", en_HK: "en-HK", en_IL: "en-IL", es_ES: "es-ES", es_MX: "es-MX", et_EE: "et-EE", fi_FI: "fi-FI", fr_FR: "fr-FR", fr_CA: "fr-CA", he_IL: "he-IL", hr_HR: "hr-HR", hu_HU: "hu-HU", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", lt_LT: "lt-LT", lv_LV: "lv-LV", nb_NO: "nb-NO", nl_NL: "nl-NL", pl_PL: "pl-PL", pt_BR: "pt-BR", ro_RO: "ro-RO", ru_RU: "ru-RU", sk_SK: "sk-SK", sl_SI: "sl-SI", sr_RS: "sr-Latn-RS", sv_SE: "sv-SE", tr_TR: "tr-TR", uk_UA: "uk-UA", zh_CN: "zh-Hans-CN", zh_HK: "zh-Hant-HK", zh_TW: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { au: "en-AU", nz: "en-NZ" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { bg: "bg-BG", cz: "cs-CZ", dk: "da-DK", de: "de-DE", at: "de-AT", ch_de: "de-CH", lu_de: "de-LU", us: "en-US", au: "en-AU", be_en: "en-BE", ca: "en-CA", cy_en: "en-CY", uk: "en-GB", gr_en: "en-GR", hk_en: "en-HK", ie: "en-IE", lu_en: "en-LU", mt: "en-MT", nz: "en-NZ", africa: "en-x-AFRICA", ar: "es-AR", cl: "es-CL", co: "es-CO", es: "es-ES", mx: "es-MX", pe: "es-PE", ee: "et-EE", fi: "fi-FI", fr: "fr-FR", be_fr: "fr-BE", ca_fr: "fr-CA", ch_fr: "fr-CH", lu_fr: "fr-LU", hu: "hu-HU", it: "it-IT", ch_it: "it-CH", jp: "ja-JP", kr: "ko-KR", lt: "lt-LT", lv: "lv-LV", no: "nb-NO", nl: "nl-NL", be_nl: "nl-BE", pl: "pl-PL", pt: "pt-PT", br: "pt-BR", ro: "ro-RO", ru: "ru-RU", sk: "sk-SK", si: "sl-SI", se: "sv-SE", hk_zh: "zh-Hant-HK" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { ar_AE: "ar-AE", bg_BG: "bg-BG", ca_ES: "ca-ES", cs_CZ: "cs-CZ", da_DK: "da-DK", de_DE: "de-DE", el_GR: "el-GR", en_US: "en-US", es_ES: "es-ES", et_EE: "et-EE", fa_IR: "fa-IR", fi_FI: "fi-FI", fr_FR: "fr-FR", he_IL: "he-IL", hi_IN: "hi-IN", ht_HT: "ht-HT", hu_HU: "hu-HU", id_ID: "id-ID", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", lt_LT: "lt-LT", lv_LV: "lv-LV", ms_MY: "ms-MY", nl_NL: "nl-NL", no_NO: "nb-NO", pl_PL: "pl-PL", pt_BR: "pt-BR", ro_RO: "ro-RO", ru_RU: "ru-RU", sk_SK: "sk-SK", sl_SI: "sl-SI", sv_SE: "sv-SE", th_TH: "th-TH", tr_TR: "tr-TR", uk_UA: "uk-UA", ur_PK: "ur-PK", vi_VN: "vi-VN", zh_CN: "zh-Hans-CN", zh_TW: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs_CZ: "cs-CZ", da_DK: "da-DK", de_DE: "de-DE", en_US: "en-US", en_GB: "en-GB", en_IL: "en-IL", en_AE: "en-AE", en_XM: "en-x-MENA", es_ES: "es-ES", es_MX: "es-MX", es_LA: "es-x-LA", es_NA: "es-x-NA", fi_FI: "fi-FI", fr_FR: "fr-FR", fr_CA: "fr-CA", fr_MA: "fr-MA", fr_XM: "fr-x-MENA", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", nb_NO: "nb-NO", nl_NL: "nl-NL", pl_PL: "pl-PL", pt_BR: "pt-BR", ru_RU: "ru-RU", sv_SE: "sv-SE", tr_TR: "tr-TR", hu_HU: "hu-HU", sk_SK: "sk-SK", sl_SI: "sl-SI", uk_UA: "uk-UA", zh_CN: "zh-Hans-CN", zh_TW: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "hu-HU": "hu-HU", "id-ID": "id-ID", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "ms-MY": "ms-MY", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "pt-PT": "pt-PT", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "th-TH": "th-TH", "tr-TR": "tr-TR", "uk-UA": "uk-UA", "zh-TW": "zh-Hant-TW", "zh-HK": "zh-Hant-HK" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { en: "en-US", en_GB: "en-GB", cs: "cs-CZ", da: "da-DK", de: "de-DE", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", uk: "uk-UA", zh_Hans: "zh-Hans-CN", zh_Hant: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { en_us: "en-US", en_au: "en-AU", en_be: "en-BE", en_br: "en-BR", en_ca: "en-CA", en_cis: "en-x-CIS", en_cy: "en-CY", en_gb: "en-GB", en_gr: "en-GR", en_il: "en-IL", en_ie: "en-IE", en_in: "en-IN", en_hk: "en-HK", en_lu: "en-LU", en_mena: "en-x-MENA", en_mt: "en-MT", en_nz: "en-NZ", en_sea: "en-x-SEA", en_za: "en-ZA", cs_cz: "cs-CZ", da_dk: "da-DK", de_de: "de-DE", de_ch: "de-CH", de_lu: "de-LU", es_es: "es-ES", es_419: "es-x-LA", es_mx: "es-MX", fr_fr: "fr-FR", fi_fi: "fi-FI", fr_ca: "fr-CA", fr_ch: "fr-CH", fr_be: "fr-BE", fr_mena: "fr-x-MENA", fr_lu: "fr-LU", it_it: "it-IT", it_ch: "it-CH", ja_jp: "ja-JP", ko_kr: "ko-KR", nb_no: "nb-NO", nl_nl: "nl-NL", pl_pl: "pl-PL", pt_pt: "pt-PT", pt_br: "pt-BR", ru_ru: "ru-RU", sv_se: "sv-SE", tr_tr: "tr-TR", zh_cn: "zh-Hans-CN", zh_tw: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cy-GB": "cy-GB", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pt-BR": "pt-BR", "sv-SE": "sv-SE", "zh-Hans-CN": "zh-Hans-CN", "zh-Hant-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", "zh-tw": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "ar-AE": "ar-AE", "bg-BG": "bg-BG", "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "et-EE": "et-EE", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "he-IL": "he-IL", "hr-HR": "hr-HR", "hu-HU": "hu-HU", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "lt-LT": "lt-LT", "lv-LV": "lv-LV", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "ro-RO": "ro-RO", "ru-RU": "ru-RU", "sk-SK": "sk-SK", "sl-SI": "sl-SI", "sr-SP": "sr-Latn-RS", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "uk-UA": "uk-UA", "zh-CN": "zh-Hans-CN", "zh-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", "zh-hans": "zh-Hans-CN", "zh-hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", cy: "cy-GB", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", uk: "uk-UA", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cy-GB": "cy-GB", "en-US": "en-US", "de-DE": "de-DE", "fr-FR": "fr-FR", "es-ES": "es-ES", "it-IT": "it-IT", "pt-BR": "pt-BR", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "da-DK": "da-DK", "nl-NL": "nl-NL", "sv-SE": "sv-SE", "fi-FI": "fi-FI", "zh-Hans-CN": "zh-Hans-CN", "zh-Hant-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { bg: "bg-BG", cz: "cs-CZ", dk: "da-DK", de: "de-DE", at: "de-AT", ch_de: "de-CH", lu_de: "de-LU", gr_en: "el-GR", cy_en: "el-CY", us: "en-US", be_en: "en-BE", ca: "en-CA", au: "en-AU", uk: "en-GB", ie: "en-IE", lu_en: "en-LU", nz: "en-NZ", ph: "en-PH", sg: "en-SG", es: "es-ES", ar: "es-AR", cl: "es-CL", co: "es-CO", cr: "es-CR", ec: "es-EC", gt: "es-GT", mx: "es-MX", pe: "es-PE", ve: "es-VE", ee: "et-EE", fi: "fi-FI", fr: "fr-FR", be_fr: "fr-BE", ca_fr: "fr-CA", ch_fr: "fr-CH", lu_fr: "fr-LU", il: "he-IL", in: "hi-IN", hu: "hu-HU", it: "it-IT", ch_it: "it-CH", jp: "ja-JP", kr: "ko-KR", lt: "lt-LT", lv: "lv-LV", mt: "mt-MT", no: "nb-NO", nl: "nl-NL", be_nl: "nl-BE", pl: "pl-PL", pt: "pt-PT", br: "pt-BR", ro: "ro-RO", ru: "ru-RU", sk: "sk-SK", si: "sl-SI", se: "sv-SE", th: "th-TH", tr: "tr-TR", ua: "uk-UA", tw: "zh-Hant-TW", hk: "zh-Hant-HK" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs_CZ: "cs-CZ", da_DK: "da-DK", de_AT: "de-AT", de_CH: "de-CH", de_DE: "de-DE", de_LU: "de-LU", en_US: "en-US", cy_EN: "en-CY", be_EN: "en-BE", ca_EN: "en-CA", en_AE: "en-AE", en_AU: "en-AU", en_BG: "en-BG", en_BH: "en-BH", en_DZ: "en-DZ", en_EE: "en-EE", en_EG: "en-EG", en_FI: "en-FI", en_HR: "en-HR", en_HU: "en-HU", en_ID: "en-ID", en_IE: "en-IE", en_IL: "en-IL", en_JO: "en-JO", en_KE: "en-KE", en_KW: "en-KW", en_LB: "en-LB", en_LK: "en-LK", en_LT: "en-LT", en_LV: "en-LV", en_MA: "en-MA", en_MT: "en-MT", en_MY: "en-MY", en_NG: "en-NG", en_NZ: "en-NZ", en_OM: "en-OM", en_QA: "en-QA", en_RO: "en-RO", en_SA: "en-SA", en_SI: "en-SI", en_SK: "en-SK", en_TH: "en-TH", en_TR: "en-TR", en_UA: "en-UA", en_UK: "en-UK", en_VN: "en-VN", gr_EN: "en-GR", lu_EN: "lu-EN", es_ES: "es-ES", es_BO: "es-BO", es_DO: "es-DO", es_MX: "es-MX", es_PA: "es-PA", es_PY: "es-PY", es_SV: "es-SV", fr_FR: "fr-FR", fr_CA: "fr-CA", fr_BE: "fr-BE", fr_CH: "fr-CH", fr_LU: "fr-LU", fr_MA: "fr-MA", it_IT: "it-IT", it_CH: "it-CH", ja_JP: "ja-JP", ko_KR: "ko-KR", nb_NO: "nb-NO", nl_NL: "nl-NL", nl_BE: "nl-BE", pl_PL: "pl-PL", pt_BR: "pt-BR", pt_PT: "pt-PT", ru_RU: "ru-RU", ru_KZ: "ru-KZ", ru_UZ: "ru-UZ", sv_SE: "sv-SE" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { bg: "bg-BG", cz: "cs-CZ", dk: "da-DK", de: "de-DE", at: "de-AT", ch_de: "de-CH", lu_de: "de-LU", gr_en: "el-GR", cy_en: "el-CY", en: "en-US", be_en: "en-BE", ca: "en-CA", au: "en-AU", uk: "en-GB", ie: "en-IE", lu_en: "en-LU", nz: "en-NZ", es: "es-ES", mx: "es-MX", ee: "et-EE", fi: "fi-FI", fr: "fr-FR", be_fr: "fr-BE", ca_fr: "fr-CA", ch_fr: "fr-CH", lu_fr: "fr-LU", hu: "hu-HU", it: "it-IT", ch_it: "it-CH", jp: "ja-JP", kr: "ko-KR", lt: "lt-LT", lv: "lv-LV", mt: "mt-MT", no: "nb-NO", nl: "nl-NL", be_nl: "nl-BE", pl: "pl-PL", pt: "pt-PT", br: "pt-BR", ro: "ro-RO", ru: "ru-RU", sk: "sk-SK", si: "sl-SI", se: "sv-SE", th: "th-TH", tr: "tr-TR", ua: "uk-UA" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "pt-BR": "pt-BR", "zh-Hans": "zh-Hans-CN" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cs-CZ": "cs-CZ", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "es-MX": "es-MX", "fi-FI": "fi-FI", "fr-CA": "fr-CA", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pl-PL": "pl-PL", "pt-BR": "pt-BR", "ru-RU": "ru-RU", "sv-SE": "sv-SE", "tr-TR": "tr-TR", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", cy: "cy-GB", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", hu: "hu-HU", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", uk: "uk-UA", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "cy-GB": "cy-GB", "da-DK": "da-DK", "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fi-FI": "fi-FI", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "nb-NO": "nb-NO", "nl-NL": "nl-NL", "pt-BR": "pt-BR", "sv-SE": "sv-SE", "zh-Hans-CN": "zh-Hans-CN", "zh-Hant-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", no: "nb-NO", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", "zh-tw": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs: "cs-CZ", da: "da-DK", de: "de-DE", en: "en-US", es: "es-ES", fi: "fi-FI", fr: "fr-FR", hu: "hu-HU", it: "it-IT", ja: "ja-JP", ko: "ko-KR", nb: "nb-NO", nl: "nl-NL", pl: "pl-PL", pt: "pt-BR", ru: "ru-RU", sv: "sv-SE", tr: "tr-TR", uk: "uk-UA", "zh-Hans": "zh-Hans-CN", "zh-Hant": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs_CZ: "cs-CZ", da_DK: "da-DK", de_DE: "de-DE", de_LU: "de-LU", el_GR: "el-GR", en_US: "en-US", en_GB: "en-GB", es_ES: "es-ES", et_EE: "et-EE", fi_FI: "fi-FI", fr_FR: "fr-FR", fr_CA: "fr-CA", hu_HU: "hu-HU", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", nb_NO: "nb-NO", nl_NL: "nl-NL", pl_PL: "pl-PL", pt_BR: "pt-BR", pt_PT: "pt-PT", ro_RO: "ro-RO", ru_RU: "ru-RU", sv_SE: "sv-SE", tr_TR: "tr-TR", uk_UA: "uk-UA", zh_CN: "zh-Hans-CN", zh_TW: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs_CZ: "cs-CZ", cy_GB: "cy-GB", da_DK: "da-DK", de_DE: "de-DE", en_US: "en-US", es_ES: "es-ES", fi_FI: "fi-FI", fr_FR: "fr-FR", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", nb_NO: "nb-NO", nl_NL: "nl-NL", pl_PL: "pl-PL", pt_PT: "pt-PT", pt_BR: "pt-BR", ru_RU: "ru-RU", sv_SE: "sv-SE", tr_TR: "tr-TR", uk_UA: "uk-UA", zh_CN: "zh-Hans-CN", zh_TW: "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { cs_CZ: "cs-CZ", da_DK: "da-DK", de_DE: "de-DE", en_US: "en-US", en_AE: "en-AE", en_GB: "en-GB", en_IL: "en-IL", es_ES: "es-ES", es_MX: "es-MX", fi_FI: "fi-FI", fr_FR: "fr-FR", fr_CA: "fr-CA", fr_MA: "fr-MA", hu_HU: "hu-HU", it_IT: "it-IT", ja_JP: "ja-JP", ko_KR: "ko-KR", nb_NO: "nb-NO", nl_NL: "nl-NL", pl_PL: "pl-PL", pt_BR: "pt-BR", ru_RU: "ru-RU", sv_SE: "sv-SE", tr_TR: "tr-TR", uk_UA: "uk-UA", zh_CN: "zh-Hans-CN", zh_TW: "zh-Hant-TW", de_AT: "de-AT", de_CH: "de-CH", de_LU: "de-LU", en_ZA: "en-x-AFRICA", en_AU: "en-AU", en_BE: "en-BE", en_CA: "en-CA", en_LU: "en-LU", en_MENA: "en-x-MENA", en_MT: "en-MT", en_NZ: "en-NZ", en_SA: "en-SA", en_SG: "en-SG", en_TH: "en-TH", en_IN: "en-IN", en_IE: "en-IE", en_GR: "en-GR", en_HK: "en-HK", en_CY: "en-CY", en_PH: "en-PH", en_ID: "en-ID", en_MY: "en-MY", en_VN: "en-VN", es_LA: "es-x-LA", es_CL: "es-CL", es_AR: "es-AR", es_PE: "es-PE", es_CO: "es-CO", fr_BE: "fr-BE", fr_CH: "fr-CH", fr_LU: "fr-LU", it_CH: "it-CH", nl_BE: "nl-BE", pt_PT: "pt-PT", zh_HK: "zh-Hant-HK", bg_BG: "bg-BG", et_EE: "et-EE", he_IL: "he-IL", lt_LT: "lt-LT", lv_LV: "lv-LV", ar_MENA: "ar-x-MENA", ar_AE: "ar-AE", ar_SA: "ar-SA", ro_RO: "ro-RO", sl_SL: "sl-SL", sk_SK: "sk-SK", th_TH: "th-TH", fil_PH: "fil-PH", id_ID: "id-ID", my_MS: "ms-MY", vn_VI: "vn-VI", in_HI: "hi-IN" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "de-DE": "de-DE", "en-US": "en-US", "es-ES": "es-ES", "fr-FR": "fr-FR", "it-IT": "it-IT", "ja-JP": "ja-JP", "ko-KR": "ko-KR", "pt-BR": "pt-BR", "ru-RU": "ru-RU" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { uk: "uk-UA", pt: "pt-BR", "ar-mena": "ar-x-MENA", "en-africa": "en-x-AFRICA", "en-cis": "en-x-CIS", "en-mena": "en-x-MENA", "en-sea": "en-x-SEA", "es-la": "es-x-LA", "ru-cis": "ru-x-CIS", zh: "zh-Hans-CN", "es-419": "es-419", "zh-CN": "zh-Hans-CN", "zh-HK": "zh-Hant-HK", "zh-TW": "zh-Hant-TW" };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { AF: [], AX: [], AL: [], DZ: ["en", "fr", "ar"], AS: [], AD: ["es", "fr", "pt"], AO: ["pt"], AI: [], AQ: ["en"], AG: ["en"], AR: ["es"], AM: ["en", "ru"], AW: [], AU: ["en"], AT: ["de"], AZ: ["en", "ru"], BS: ["en"], BH: ["ar", "en"], BD: [], BB: ["en"], BY: ["ru"], BE: ["nl", "en", "fr"], BZ: [], BJ: [], BM: ["en"], BT: [], BO: ["es"], BA: ["en"], BW: ["en"], BV: [], BR: ["pt"], IO: [], BN: ["en"], BG: ["bg"], BF: [], BI: ["en", "fr"], KH: [], CM: ["en", "fr"], CA: ["en", "fr"], CV: [], KY: ["en"], CF: [], TD: [], CL: ["es"], CN: ["zh-Hans"], CX: [], CC: ["en"], CO: ["es"], KM: [], CG: ["en", "fr"], CD: ["en", "fr"], CK: [], CR: ["es"], CI: ["en", "fr"], HR: ["hr", "en"], CU: [], CY: ["en"], CZ: ["cs"], DK: ["da"], DJ: [], DM: ["en"], DO: ["es"], EC: ["es"], EG: ["ar", "en"], SV: ["es"], GQ: [], ER: [], EE: ["et"], ET: [], FK: [], FO: ["da"], FJ: [], FI: ["fi"], FR: ["fr"], GF: ["fr"], PF: [], TF: [], GA: [], GM: [], GE: ["en", "ru"], DE: ["de"], GH: ["en"], GI: [], GR: ["el", "en"], GL: [], GD: [], GP: ["en", "fr"], GU: [], GT: ["es"], GG: [], GN: [], GW: [], GY: ["en"], HT: ["en", "fr"], HM: [], VA: [], HN: ["es"], HK: ["en", "zh-Hant"], HU: ["hu"], IS: [], IN: ["en"], ID: ["id", "en"], IR: [], IQ: ["ar"], IE: ["en"], IM: [], IL: ["he", "en"], IT: ["it"], JM: ["en"], JP: ["ja"], JE: [], JO: ["ar", "en"], KZ: ["ru"], KE: ["en"], KI: [], KR: ["ko"], KV: [], KW: ["ar", "en"], KG: ["ru", "en"], LA: [], LV: ["lv"], LB: ["en", "ar"], LS: ["en"], LR: ["en"], LY: ["ar"], LI: [], LT: ["lt"], LU: ["en", "de", "fr"], MO: ["en", "zh-Hant"], MK: [], MG: ["en", "fr"], MW: [], MY: ["ms", "en"], MV: [], ML: ["en", "fr"], MT: ["en"], MH: [], MQ: ["en", "fr"], MR: ["en", "fr"], MU: ["en", "fr"], YT: ["en", "fr"], MX: ["es"], FM: ["en"], MD: ["en", "ru"], MC: [], MN: [], ME: [], MS: [], MA: ["en", "fr", "ar"], MZ: ["pt"], MM: [], NA: ["en"], NR: [], NP: [], NL: ["nl"], AN: ["nl", "en"], NC: [], NZ: ["en"], NI: ["es"], NE: ["en", "fr"], NG: ["en"], NU: [], NF: [], MP: ["en"], NO: ["nb"], OM: ["ar", "en"], PK: ["en"], PW: [], PS: [], PA: ["es"], PG: [], PY: ["es"], PE: ["es"], PH: ["en"], PN: [], PL: ["pl"], PT: ["pt"], PR: ["es"], QA: ["ar", "en"], RE: [], RO: ["ro"], RU: ["ru"], RW: [], BL: [], SH: [], KN: ["en"], LC: ["en"], MF: [], PM: [], VC: ["pt"], WS: [], SM: [], ST: [], SA: ["ar", "en"], SN: ["en", "fr"], RS: ["rs"], SC: [], SL: [], SG: ["en"], SK: ["sk"], SI: ["sl"], SB: [], SO: [], ZA: ["en"], GS: [], ES: ["es", "ca", "eu"], LK: ["en"], SD: [], SR: ["nl"], SJ: [], SZ: [], SE: ["sv"], CH: ["de", "fr", "it"], SY: [], TW: ["zh-Hant"], TJ: ["ru", "en"], TZ: ["en"], TH: ["th", "en"], TL: [], TG: [], TK: [], TO: [], TT: ["en"], TN: ["en", "fr", "ar"], TR: ["tr"], TM: ["en", "ru"], TC: ["en"], TV: [], UG: ["en"], UA: ["uk"], AE: ["en", "ar"], GB: ["en"], US: ["en"], UM: [], UY: ["es"], UZ: ["ru", "en"], VU: [], VE: ["es"], VN: ["vi", "en"], VG: ["en"], VI: [], WF: [], EH: [], YE: ["en", "ar"], ZM: ["en"], ZW: ["en"] };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = function(a) {
      if (a && a.__esModule) return a;
      var o = {};
      if (a != null) for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (o[s] = a[s]);
      return o.default = a, o;
    }(r(3));
    t.default = function(a) {
      return n[a] && Object.keys(n[a]);
    };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.GLOBAL_REGION_TRANSLATIONS = void 0;
    var n, a = r(2), o = (n = a) && n.__esModule ? n : { default: n }, s = r(0), i = { cs: "Globální", cy: "Byd-eang", da: "Global", de: "Global", en: "Global", es: "Global", fi: "Kansainvälinen", fr: "Global", hu: "Globális", it: "Globale", ja: "グローバル", ko: "글로벌", nb: "Global", nl: "Wereldwijd", pl: "Cały świat", pt: "Global", ru: "Глобальный", sv: "Globalt", tr: "Global", uk: "Весь світ", "zh-Hans": "全球", "zh-Hant": "全球" };
    t.default = function(c) {
      var l = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en-US", d = o.default.get(c), p = d && d.regions || [];
      if (p.length > 0 && l === !0) {
        var b = Intl.DisplayNames && new Intl.DisplayNames([u], { type: "region" }), g = i[(0, s.langScript)(u, c)] || "Global";
        return p.map(function(h) {
          return { code: h, name: h === "ZZ" ? g : b && b.of(h) };
        });
      }
      return p;
    }, t.GLOBAL_REGION_TRANSLATIONS = i;
  }, function(e, t) {
    var r, n, a = e.exports = {};
    function o() {
      throw new Error("setTimeout has not been defined");
    }
    function s() {
      throw new Error("clearTimeout has not been defined");
    }
    function i(m) {
      if (r === setTimeout) return setTimeout(m, 0);
      if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(m, 0);
      try {
        return r(m, 0);
      } catch {
        try {
          return r.call(null, m, 0);
        } catch {
          return r.call(this, m, 0);
        }
      }
    }
    (function() {
      try {
        r = typeof setTimeout == "function" ? setTimeout : o;
      } catch {
        r = o;
      }
      try {
        n = typeof clearTimeout == "function" ? clearTimeout : s;
      } catch {
        n = s;
      }
    })();
    var c, l = [], u = !1, d = -1;
    function p() {
      u && c && (u = !1, c.length ? l = c.concat(l) : d = -1, l.length && b());
    }
    function b() {
      if (!u) {
        var m = i(p);
        u = !0;
        for (var R = l.length; R; ) {
          for (c = l, l = []; ++d < R; ) c && c[d].run();
          d = -1, R = l.length;
        }
        c = null, u = !1, function(T) {
          if (n === clearTimeout) return clearTimeout(T);
          if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(T);
          try {
            return n(T);
          } catch {
            try {
              return n.call(null, T);
            } catch {
              return n.call(this, T);
            }
          }
        }(m);
      }
    }
    function g(m, R) {
      this.fun = m, this.array = R;
    }
    function h() {
    }
    a.nextTick = function(m) {
      var R = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var T = 1; T < arguments.length; T++) R[T - 1] = arguments[T];
      l.push(new g(m, R)), l.length !== 1 || u || i(b);
    }, g.prototype.run = function() {
      this.fun.apply(null, this.array);
    }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = h, a.addListener = h, a.once = h, a.off = h, a.removeListener = h, a.removeAllListeners = h, a.emit = h, a.prependListener = h, a.prependOnceListener = h, a.listeners = function(m) {
      return [];
    }, a.binding = function(m) {
      throw new Error("process.binding is not supported");
    }, a.cwd = function() {
      return "/";
    }, a.chdir = function(m) {
      throw new Error("process.chdir is not supported");
    }, a.umask = function() {
      return 0;
    };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = s(r(6)), a = s(r(5)), o = r(0);
    function s(i) {
      return i && i.__esModule ? i : { default: i };
    }
    t.default = function(i, c, l) {
      var u = (0, o.getAppNameFromURL)(i), d = (0, a.default)(u, c, l), p = d.locale;
      return { match: d.match, url: (0, n.default)(i, p) };
    };
  }, function(e, t, r) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n, a = r(1), o = (n = a) && n.__esModule ? n : { default: n }, s = r(0), i = r(2);
    t.default = function(c) {
      var l = void 0;
      if (typeof c == "string") {
        var u = (0, s.getAppNameFromURL)(c);
        if (u) {
          var d = i.langParamApp.includes(u) ? "lang" : "locale", p = new RegExp("(" + d + "=)(.*?)(?=&|$)");
          l = (c.match(p) || [])[2] || "", l = (0, o.default)(u, l, "en-US");
        }
      }
      return l;
    };
  }]);
};
var Fr = Hr.exports = it();
const st = ["cs-CZ", "da-DK", "de-DE", "en-US", "es-ES", "fi-FI", "fr-FR", "it-IT", "ja-JP", "ko-KR", "nb-NO", "nl-NL", "pl-PL", "pt-BR", "ru-RU", "sv-SE", "tr-TR", "zh-CN", "zh-TW", "zz-ZZ"], q = "en-US";
let se, ut = { dateTime: {}, number: {}, message: {}, relativeTime: {}, pluralRules: {}, list: {}, displayNames: {} };
pt(zr());
const Q = {};
wr("US");
const Zr = (e, t) => class extends e {
  constructor() {
    super(...arguments), this.onLocaleChange = () => {
      this.requestUpdate();
    };
  }
  connectedCallback() {
    super.connectedCallback(), lt(t, q), document.addEventListener(Ee.EVENT_NAME, this.onLocaleChange);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener(Ee.EVENT_NAME, this.onLocaleChange);
  }
  getLocale() {
    return $();
  }
  t(r, n) {
    return Kr(r, n);
  }
};
function lt(e = {}, t) {
  Q[t || $()] = { ...Q[t || $()], ...e }, se = ft();
}
function Vr() {
  return window.__i18n_country_code;
}
function $() {
  return window.__i18n_current_locale;
}
function zr() {
  return ct(navigator.language) ? navigator.language : q;
}
function Wr(e) {
  return e && e.split("-")[0];
}
function Jr(e, t) {
  return t && ct(t) && t !== q ? Fr.getLocalizedURL(e, t) : e;
}
function ct(e) {
  return st.includes(e);
}
function wr(e) {
  window.__i18n_country_code = e;
}
function Xr(e, t) {
  st.includes(e) && (t && lt(t, e), pt(e), ut = { dateTime: {}, number: {}, message: {}, relativeTime: {}, pluralRules: {}, list: {}, displayNames: {} }, se = ft(), document.dispatchEvent(new Ee(e)));
}
function Kr(e, t) {
  return se && se.formatMessage({ id: e, defaultMessage: Q[q] && Q[q][e] }, t) || e;
}
function ft() {
  return Dr({ locale: $(), messages: Q[$()] }, ut);
}
function pt(e) {
  window.__i18n_current_locale = e;
}
export {
  q as DEFAULT_LOCALE,
  Zr as Localize,
  lt as addMessages,
  Vr as getCountryCode,
  $ as getLocale,
  zr as getLocaleFromBrowser,
  Jr as getLocalizedURL,
  Wr as getShortLanguageCode,
  ct as isSupportedLocale,
  wr as setCountryCode,
  Xr as setLocale,
  Kr as t
};
//# sourceMappingURL=I18N.js.map
